//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { CaretDownOutlined } from '@ant-design/icons';
import React, { memo, use, useEffect, useMemo, useReducer, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
//  -- Components ---------------------
import { Button, Modal, TextField, Tooltip } from '@mui/material';
import { MoreVert, Warning , SyncDisabled, Search } from '@mui/icons-material';
import { Dropdown, message } from 'antd';
import { Tooltip as AntdTooltip } from 'antd';
import { useAlertLoading } from 'components/UI/alertSakeBar/alertProvider';
import Loading from 'components/Loading';
import { useLocation, useNavigate } from "react-router-dom";
import { handleChangeStatusActivity, handleDeleteClassActivity, handleHiddenStatusActivity, handleListClassActivities } from 'store/classActivities/thunks';
import { handleChangeStatusQuizzes, handleDeleteClassQuiz, handleListClassQuizzes } from 'store/classQuizzes/thunks';
import { useExams } from 'store/exams/selectors';
import { Popover } from 'antd';
import GradebookPopoverContent from 'components/UI/PopoverConf/GradebookPopover';
import { InfoCircleFilled } from '@ant-design/icons';
//  -- Constants ----------------------
import COLOR from 'utils/constants/color';

//  -- Features -----------------------
import GradeEditor from 'features/forms/GradeEditor';

//  -- Thunks -------------------------
import { TootipWrapper } from 'components/TooltipWrapper';
import { debounce, filter, find, get, groupBy, has, map, orderBy as lodashOrderBy, uniqBy, floor } from 'lodash';
import moment from "moment";
import { useCallback } from 'react';
import { useBookUnits } from "store/booksUnits/selectors";
import { handleDeleteGoogleAssignment, handleSyncAssignmentGradeToGoogleClassroom, handleUpdateGoolgeGradeInBatch } from 'store/googleClassRoom/thunks';
import { useResources, useVideos } from 'store/resources/selectors';
import { useSchoologyAssignment, useSchoologyGradeCategory } from "store/schoologyauth/selectors";
import { useStory } from "store/story/selectors";
import { handleListClassSubmissions, handleUpdateSubmission, handleUpdateSubmissionsToAll } from 'store/submissions/thunks';
import { handleListClassUsers } from 'store/userClasses/thunks';
import { handleGetUserPreference } from 'store/userPreference/thunks';
import { handleDeleteUserData } from 'store/users/thunks';
import { handleDeleteSchoologyAssignment, handleGradeToSchoology, handleSyncAssignmentDataSchoology, handleSyncGradeFromSchoologyByAssignment, handleSyncGradesToSchoology, handleSyncGradeToSchoologyByAssignment, handleSyncSchoologyClassesGrades} from "store/schoology/thunks"
import { BACK_TO_BOOK } from 'utils/config/reference';
import { checkIsDiffForUser, generateUrlForNonEbook, getAssignmentLable, getBookDisplayName, getStoryUrl, isBookAllowed, isVideo } from 'utils/lib/ebookHelper';
import { af_grade, checkHasAutoGrade, checkIsManualGradable, getCurrenSem, isBeforTime, semeterDateByYear, getSem1EndDate, getSem2StartDate } from "utils/methods/math";
import ExamTables from "./ExamGradeTable";

import { handleDeleteCanvasAssignment, handleSyncFromCanvas, handleSyncTOCanvas , handleUpdateCanvasGradeInBatch } from "store/canvas/thunks";
import { openLoginInNewWindow } from "store/keystore/thunks";
import { handledeleteDebate } from 'store/debate/thunks';
import { useClassGameActivity } from 'store/one_game/selectors';
import ParentInvitationModal from 'containers/parent/ParentInvitationModal';
import ModalMenu from 'components/Modals';
import { useCollectionNotification } from 'utils/methods/firebaseNotification';
import { v4 } from 'uuid';
import { useClassUsers } from 'store/userClasses/selectors';
import SentryWrap from 'components/Sentry';
import RenderIfVisible from 'react-render-if-visible'
import * as Sentry from "@sentry/react";
import ReturnAssignmentByStudent from 'components/gradebook/ReturnAssignmentByStudent';
import { useCurrentClassBook } from 'store/classes/selectors';
import { useUserAllowedBooks } from 'store/books/selectors';
import { handleGetParentByStudentId } from 'store/email/thunks';
import SpinLoader from 'components/Loader/SpinLoader';
import Acent from 'components/Acent';
import ParentLogin from 'modules/parentLogin';
import { useSocket } from 'store/chat/selectors';
import ReportIssueModal from 'components/Modals/ReportIssueModal';
import StudentDifferentiationBulkModal from 'components/gradebook/StudentDifferentiationBulkModal';
import { useGradeBook } from 'components/hooks/gradeBook/useGradeBook';
import { useParentOrgId } from 'store/organizations/selectors';
import { getDateOnlyRangeBounds, getDefaultGradeTableDateRange } from 'utils/methods/gradebookDateRange';
import { studentMatchesGradebookActiveFilter } from 'utils/methods/gradebookStudentActiveFilter';
import { DateRangeDropdown } from 'components/GradeDownloader';
import PasswordViewerModal from 'components/PasswordViewerModal';
import { updateUI } from 'store/UI/actions';
import { handleGetClass } from 'store/classes/thunks';

const rowOneColor = "#7ed6df"
const rowTwoColor = "#03989e"
const rowSemester = COLOR.OrangeExam
const MIN_GRADE_TABLE_COLUMNS = 8;
const rowThreeColor = "#0abde3"
const getKey = (sem, year) => (`${sem == 1 ? "semester 1" : "semester 2"} - ${year}`)
const ACTIVE_BTN_COLOR = `linear-gradient(to bottom right, ${COLOR.indigo100} , ${COLOR.indigo300})`
const getBgColorSemester = (isActive) => isActive ? ACTIVE_BTN_COLOR : rowSemester
const NAME_SHORTING = [{ key: "last_a_z", title: "Last Name, A-Z" }, { key: "last_z_a", title: "Last Name, Z-A" }, { key: "first_a_z", title: "First Name, A-Z" }, { key: "first_z_a", title: "First Name, Z-A" }]
const getGradebookOrderDateValue = (item, orderByDate) => {
    if (orderByDate === 'due_date') {
        return item.dueDate || item.scheduleAt;
    }
    if (orderByDate === 'late_submission') {
        return item.lateDate || item.dueDate;
    }
    return item.scheduleAt || item.dueDate;
};
const getGradebookOrderDaySortValue = (item, orderByDate) => {
    const raw = getGradebookOrderDateValue(item, orderByDate);
    if (!raw) return Number.POSITIVE_INFINITY;
    const m = moment(raw);
    return m.isValid() ? m.startOf('day').valueOf() : Number.POSITIVE_INFINITY;
};
const getGradebookAssignmentSequence = (item) => {
    const raw = get(item, 'meta_data.sequence');
    const fallback = get(item, 'data.meta_data.sequence');
    const v = raw !== undefined && raw !== null && raw !== '' ? Number(raw) : Number(fallback);
    return Number.isFinite(v) && v > 0 ? v : Number.MAX_SAFE_INTEGER;
};
const TABLE_CELL_HEIGHT = '60px';
const TABLE_CELL_MIN_WIDTH = 150

const getSemDateTime = (sem, parentOrgId) => {
    let dt = sem.split(" ")
    const year = dt[3]
    const semNum = dt[1]
    const { sem1EndDate, sem1StartDate, sem2EndDate, sem2StartDate } = semeterDateByYear(year, parentOrgId)
    if (semNum == 1) {
        return ({ start: sem1StartDate, end: sem1EndDate })
    } else {
        return ({ start: sem2StartDate, end: sem2EndDate })
    }

}


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const CustomBtn = styled.button`
    align-items: center;
    background-color: transparent;
    border: none;
    color: ${COLOR.black300};
    cursor: pointer;
    display: flex;
    justify-content: center;
    margin-right: 4px;
    outline: none;

    &:hover {
        color: ${COLOR.green100};
    }
`;

const ModalContent = styled.div`
    align-items: center;
    background-color: ${COLOR.white};
    border-radius: 3px;
    display: inline-flex;
    flex-direction: column;
    left: 50%;
    max-width: 320px;
    padding: 16px;
    position: absolute;
    text-align: center;
    top: 50%;
    transform: translate(-50%, -50%);
`;

const ModalRow = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 16px;
    width: 100%;
`;


// border-right-color:${COLOR.black100}
const OverflowOne = styled.div`
    height: auto;
    width: 417px;
    display: inline-block;
    border-right: 1px solid black;
    @media (max-width: 634px){
    
    }
`;
const OverflowTwo = styled.div`
    height: auto;
    display: inline-block;
    @media (max-width: 634px) {
       
    }
`;

const AssignmentDeleteWrapper = styled.div`
   cursor:pointer;
   margin-top: 5px;
   opacity:0;
`;

const TableCell = styled.div`
    text-align: center;
    align-items: center;
    background-color: ${p => !p.header && (p.active ? '#03989e82' : 'transparent')};
    color: ${p => p.header && (p.active ? COLOR.green100 : COLOR.black500)};
    display: flex;
    font-size: ${p => p.header && '11px'};
    font-weight: ${p => p.active ? 600 : 500};
    height: ${p => p.header ? '16px' : '48px'};
    justify-content: ${p => p.start ? 'flex-start' : 'center'};
    min-width: ${p => p.minWidth ? `${p.minWidth}px` : p.width};
    text-transform: ${p => p.header && 'uppercase'};
    transition: all 300ms ease;
    white-space: nowrap;
    width: ${p => p.width || '56px'};
    justify-content: center;
    overflow:hidden;
    &:first-child {
        justify-content: flex-start;
    }
    &:hover ${AssignmentDeleteWrapper} {
        opacity: ${p => p.disabled ? 0 : 1};
    }
`;

const DueDateTableCell = styled(TableCell)`
   background-color: ${p => p.is_hidden ? "#e0e0e0" : rowThreeColor};
   opacity:${p=>p.is_hidden?"0.6":"1"};
   color: black;
   height: 30px; 
   font-size: 12px;
   font-weight: bold;
   border-right: 1px solid ${COLOR.black100};
   text-align: center;
   justify-content: center !important;
`;
const AssignmentTableCell = styled(TableCell)`
   background-color: ${p => p.is_hidden ? "#03989e" : p.assignmentActive ? rowTwoColor : COLOR.redishpink};
   opacity:${p=>p.is_hidden?"0.6":"1"};
   color: ${p=>p.is_hidden?"#060606":"white"};
   height: 30px; 
   font-size: 12px;
   font-weight: bold;
   border-right: 1px solid ${COLOR.black100};
   text-align: center;
   justify-content: center !important;
   cursor: pointer;
   padding: 0 3px;
   position: sticky;
   top: 0;
   z-index: 9;
`;
const BookLabelTableCell = styled(TableCell)`
   background-color: ${p => p.is_hidden ? "#e0e0e0": rowOneColor};
   opacity:${p=>p.is_hidden?"0.6":"1"};
   color: black;
   height: 30px; 
   font-size: 10px;
   font-weight: bold;
   border-right: 1px solid ${COLOR.black100};
   text-align: center;
   justify-content: center !important;
   cursor: pointer;
   padding-left: 4;
   padding-right: 4;
   padding: 0 3px;
`;
const AverageTableCell = styled(TableCell)`
   width:208px;
   font-size: 14px;
   height:${TABLE_CELL_HEIGHT};
`;
const UserNameCellTableCell = styled(TableCell)`
   width:208px;
   color:${p => p.userActive ? "inherit" : COLOR.radish100};
   height:${TABLE_CELL_HEIGHT};
   position: sticky;
   left: 0;
   z-index: 20;
   @media Screen and (max-width: 600px) {
    position: initial;
   }
`;

const StudentFilterWrap = styled.div`
   width: 100%;
   display: flex;
   justify-content: flex-end;
   align-items: center;
   gap: 8px;
   @media screen and (max-width: 600px) {
    flex-wrap: wrap;
   }
`;

const StudentSearchByButton = styled.button`
   height: 28px;
   min-width: 120px;
   border: 1px solid ${COLOR.black100};
   border-radius: 6px;
   background: ${COLOR.white};
   color: ${COLOR.black300};
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 0 10px;
   cursor: pointer;
`;

const StudentSearchInputWrap = styled.div`
   height: 28px;
   width: 100%;
   max-width: 300px;
   border: 1px solid ${COLOR.black100};
   border-radius: 6px;
   background: ${COLOR.white};
   display: flex;
   align-items: center;
   padding: 0 8px;
   @media screen and (max-width: 600px) {
    max-width: 100%;
   }
`;

const StudentSearchInput = styled.input`
   border: none;
   outline: none;
   width: 100%;
   height: 100%;
   color: ${COLOR.black300};
   font-size: 12px;
`;

const StudentSearchOptionItem = styled.div`
   display: block;
   width: 100%;
   box-sizing: border-box;
   padding: 8px 10px;
   border-radius: 6px;
   font-size: 12px;
   font-weight: 500;
   line-height: 1.2;
   cursor: pointer;
   transition: all 0.2s ease;
   background: ${p => p.$active ? COLOR.indigo600 : COLOR.white};
   color: ${p => p.$active ? COLOR.white : COLOR.gray100};
   &:hover {
      background: ${p => p.$active ? COLOR.indigo600 : "#f5f7ff"};
      color: ${p => p.$active ? COLOR.white : COLOR.indigo600};
   }
`;

const TableCellSemester = styled.div`
    text-align: center;
    align-items: center;
    background-image: ${p => p.bgColor ? `linear-gradient(to right, ${p.bgColor} , ${p.bgColor})` : getBgColorSemester(p.active)};
    color: ${p => p.header && (p.active ? COLOR.green100 : COLOR.black500)};
    display: flex;
    font-size: ${p => p.header && '11px'};
    font-weight: ${p => p.active ? 600 : 500};
    height: ${p => p.header ? '16px' : '48px'};
    justify-content: ${p => p.start ? 'flex-start' : 'center'};
    min-width: ${p => p.minWidth ? `${p.minWidth}px` : p.width};
    text-transform: ${p => p.header && 'uppercase'};
    transition: all 300ms ease;
    white-space: nowrap;
    width: ${p => p.width || '56px'};
    justify-content: center;
    &:first-child {
        justify-content: flex-start;
    }
    &:hover ${AssignmentDeleteWrapper} {
        opacity: ${p => p.disabled ? 0 : 1};
    }
`;

const TableCellExam = styled.div`
    text-align: center;
    align-items: center;
    background-image: linear-gradient(90deg, ${COLOR.PinkExam} 0%, ${COLOR.OrangeExam} 100%); 
    color: ${p => p.header && (p.active ? COLOR.green100 : COLOR.black500)};
    display: flex;
    font-size: ${p => p.header && '11px'};
    font-weight: ${p => p.active ? 600 : 500};
    height: ${p => p.header ? '16px' : '48px'};
    justify-content: ${p => p.start ? 'flex-start' : 'center'};
    min-width: ${p => p.minWidth ? `${p.minWidth}px` : p.width};
    text-transform: ${p => p.header && 'uppercase'};
    transition: all 300ms ease;
    white-space: nowrap;
    width: ${p => p.width || '56px'};
    justify-content: center;
    &:first-child {
        justify-content: flex-start;
    }
    &:hover ${AssignmentDeleteWrapper} {
        opacity: ${p => p.disabled ? 0 : 1};
    }
`;

const TableCellEdit = styled.div`
    cursor: ${p => !p.userActive ? 'default' : 'pointer'};
    align-items: center;
    background-color: ${p => !p.header && (p.active ? '#03989e82' : 'transparent')};
    opacity:${p=>p.is_hidden?"0.6":"1"};
    color: ${p => p.header && (p.active ? COLOR.green100 : COLOR.black500)};
    display: flex;
    font-size: ${p => p.header && '11px'};
    font-weight: ${p => p.active ? 600 : 500};
    height: ${TABLE_CELL_HEIGHT};
    justify-content: ${p => p.start ? 'flex-start' : 'center'};
    min-width: ${p => p.minWidth ? `${p.minWidth}px` : p.width};
    text-transform: ${p => p.header && 'uppercase'};
    transition: all 300ms ease;
    white-space: nowrap;
    width: ${p => p.width || '56px'};
    border-right: 1px solid ${COLOR.black100};
    &:first-child {
        justify-content: flex-start;
    }
    &:hover {
        color: white;
    }
`;

const TableHeader = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 4px;
    position: sticky;
    top: ${v => v.stickyTop ? v.stickyTop : 'auto'};
    background-color: white;
    border-bottom: 1px solid ${COLOR.black100};
    z-index:1;
`;

const TableRow = styled.div`
    align-items: center;
    background-color: ${p => p.active ? '#03989e82' : p.index % 2 === 0 ? 'rgb(243, 249, 255)' : 'transparent'};
    border-bottom: 1px solid;
    color: ${COLOR.black200};
    display: flex;
    flex-direction: row;
    width: auto;
`;

const Table = styled.div`
    padding-bottom: 0px;
`;

const StudentEmptyPlaceholder = styled.div`
    width: 100%;
    min-width: 0;
    min-height: ${TABLE_CELL_HEIGHT};
    display: block;
    color: ${COLOR.gray100};
    font-size: 12px;
    font-weight: 500;
    background: ${COLOR.white};
    border-bottom: 1px solid ${COLOR.black100};
    white-space: normal;
    text-align: center;
    padding: 10px 8px;
    box-sizing: border-box;
`;

const AssignmentSearchEmptyState = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${COLOR.white};
    color: ${COLOR.gray100};
    font-size: 13px;
    font-weight: 500;
    text-align: center;
    padding: 24px;
    z-index: 5;
    box-sizing: border-box;
`;


const Wrapper = styled.div`
    width: 100%;
`;

const Row = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 16px;
    width: 100%;
`;
const Rows = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 16px;
    width: 100%;
    align-items: center;
    justify-content:center;
`;
const BookNameTitle = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width:100%;
  `;


const PaddedBtn = styled.button`
    background-color: transparent;
    border: none;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    outline: none;
    padding: 8px;
    text-align: left;
    width: 100%;
`;
const TableWrapper = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    border-right: none;
    margin-bottom: 52px;
    @media (max-width: 634px){
        width: 100%;
        // overflow: scroll;
    }
`;
const Cell = styled.div`
  display: table-cell;

  min-width: 150px;

  padding: 8px;

  border: 1px solid #ccc;

  text-align: center;

  background: ${(props) => (props.isHeader ? "#f0f0f0" : "white")};

  font-weight: ${(props) => (props.isHeader ? "bold" : "normal")};
`;

const Container = styled.div`
  overflow: auto;
  max-height: 100vh;
  width: 100%;
  @media (max-width: 1366px){
    // max-height:98vh;
    max-height: initial !important;
    padding-bottom:70px;
    }
`;
const HeaderRow = styled(Row)`
  position: sticky;
  top: 0;
  background: white;
  z-index: 1;
`;

const StickyCell = styled(Cell)`
  position: sticky;
  left: ${(props) => props.left}px;
  background: ${(props) => (props.isHeader ? "white" : "#f9f9f9")};
  z-index: ${(props) => (props.isHeader ? 9 : 2)};
  @media Screen and (max-width: 600px){
    position:initial;
  }
`;

const TableWrapperInner2 = styled.div`
    position: relative;
    flex: 1;
    min-width: 0;
    // overflow: scroll;
    // overflow-y: hidden;
    @media (max-width: 634px){
        // overflow: visible;

    }
    ::-webkit-scrollbar {
        width: 3px;
        height: 12px;
    }
    ::-webkit-scrollbar-thumb {
        background-color: darkgrey;
        outline: 1px solid slategrey;
      }
`;
const AssignmentLabelText = styled.span`
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
`;
const Grid = styled.div`
  display: table;
  min-width: 100%;
  border-spacing: 0;
`;
//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Gradebook
//
//  -- Description
//  District and class announcements
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  <Gradebook />
//

function calculateNewActiveIndex(index, numCols, numRows, deletedColIndex) {
    // Step 1: Calculate current row and column
    const rowIndex = Math.floor(index / numCols);
    const colIndex = index % numCols;
  
    // Step 2: Calculate the new column index
    let newColIndex;
    if (colIndex > deletedColIndex) {
      newColIndex = colIndex - 1; // Shift left
    } else if (colIndex === deletedColIndex) {
      newColIndex = Math.max(0, colIndex - 1); // Move left, but ensure it doesn't go below 0
    } else {
      newColIndex = colIndex; // No change
    }
  
    // Step 3: Calculate the new active index
    const newIndex = rowIndex * (numCols - 1) + newColIndex;
  
    // Ensure the new index is valid
    if (newIndex >= numRows * (numCols - 1)) {
      return -1; // Optional: Return -1 to indicate an invalid index
    }
  
    return newIndex;
  }

const sortname = (a, b) => {
    const nameA = a?.lastName?.toLowerCase()?.replace(/\s/g, '');
    const nameB = b?.lastName?.toLowerCase()?.replace(/\s/g, '');;
    if (nameA < nameB) { return -1 }
    else if (nameA > nameB) { return 1 }
    else { return 0 }
}
const SemesterToShow = (parentOrgId) => {
    const currentYear = moment().get("year");
    const lastYear = currentYear - 1;
    const semYearToShow = { sem1: '', sem2: '' }
    const currentSem = getCurrenSem(parentOrgId);
    const isSpecial = parentOrgId && ['e5dcb06f-f78d-457a-bacf-8fa357b38ee2', '37ae9554-0da4-4d62-b04f-ec500b0275a4'].includes(parentOrgId);
    
    if (isSpecial) {
        const today = moment();
        const sem1EndDay = getSem1EndDate(parentOrgId);
        if (currentSem.includes("semester 1")) {
            const sem1Parts = currentSem.split(" - ");
            const sem1Year = sem1Parts[1];
            semYearToShow.sem1 = getKey(1, sem1Year);
            if (today.month() === 0 && today.date() <= sem1EndDay) {
                semYearToShow.sem2 = getKey(2, currentYear.toString());
            } else {
                semYearToShow.sem2 = getKey(2, currentYear.toString());
            }
        } else {
            semYearToShow.sem1 = getKey(1, lastYear.toString());
            semYearToShow.sem2 = getKey(2, currentYear.toString());
        }
    } else {
        const { sem2StartDate, sem2EndDate } = semeterDateByYear(currentYear, parentOrgId)
        if (moment().isSameOrAfter(sem2StartDate) && moment().isSameOrBefore(sem2EndDate)) {
            semYearToShow.sem1 = getKey(1, lastYear.toString());
            semYearToShow.sem2 = getKey(2, currentYear.toString());
        } else {
            semYearToShow.sem1 = getKey(1, currentYear.toString());
            semYearToShow.sem2 = getKey(2, currentYear.toString());
        }
    }
    return semYearToShow;

}
const getDefaultAssignmentData = (parentOrgId) => {
    const defaultAssignmentData = {}
    defaultAssignmentData[getCurrenSem(parentOrgId)] = new Array(8).fill({}, 0, 8)
    return defaultAssignmentData
}

const hasGradeInA_F = (val) => {
    const gradeLookup = {
        'a': 90, 'b': 70, 'c': 50, 'd': 30, 'f': 10
    };

    if (typeof val === "string") {
        const lowerVal = val.toLowerCase();
        if (lowerVal in gradeLookup) {
            return {
                value: gradeLookup[lowerVal],
                hasValue: true
            };
        }
    }

    return {
        value: val,
        hasValue: false
    };
};

const TableCellEditMemo = memo(TableCellEdit, (prevProps, nextProps) => {
    return prevProps.assignemnt === nextProps.assignemnt &&
        prevProps.student_submission === nextProps.student_submission &&
        prevProps.userActive === nextProps.userActive &&
        prevProps.is_hidden === nextProps.is_hidden;
});

const GradeTable = ({
    activities,
    currentClass,
    currentOrg,
    dataLoading,
    quizzes,
    users,
    reviewAssignment,
    userReviewAssignment,
    setUserData,
    submissions,
    toggleUserDrawer,
    setEditing,
    toggleChangePasswordDrawer,
    booksAllList,
    isReviewAccount,
    handleEditQuiz,
    handleEditActivity,
    currentUser,
    userPreference,
    classActivities,
    classQuizzes,
    setGradeViw,
    setExamData,
    setGradeData,
    getAssignmentCreation,
    orderBy,
    datePrefrences,
    editPrevSemData,
    setCurrentSem,
    setSortBy,
    highlightConfig,
    activeInactive,
    onSemesterChange,
    gradeDownloaderRef,
    gradeTableDateRange: gradeTableDateRangeProp,
    onGradeTableDateRangeChange
}) => {
    const {showAlert, setAlertLoading} = useAlertLoading();
    const dispatch = useDispatch();
    const classUsers = useClassUsers();
    const tableWrapperRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const story = useStory()
    const parentOrgId = useParentOrgId();
    const currentSem = getCurrenSem(parentOrgId)
    const {createCollectionNotification} = useCollectionNotification();
    const [open, setModalState] = useState(false);
    const [dectiavateByStudentModal, setDectivateByStudent] = useState({open: false, assignmentData: {}});
    const [returnSubmissonModal, setReturnSubmission] = useState({open: false, submissionList: []});
    const [gradePopulateModal,setGradePopulateModal] = useState(false);
    const [inviteParentModal,setInviteParentModal] = useState(false);
    const [selectedPopulateAssignment,setSelectedPopulateAssignment] = useState(null);
    const [loaderPopulateAssignment,setloaderPopulateAssignment] = useState(null);
    const [schoologyGradeCategory,] = useSchoologyGradeCategory()
    const [gradeToAll,setGradeToAll] = useState(null);
    const [showConfirmationModal,setShowConfirmationModal] = useState(false);
    const [showHideConfirmationModal, setShowHideConfirmationModal] = useState(false);
    const [hideConfirmationData, setHideConfirmationData] = useState({ assignment: null, is_hidden: false, sub_type: null });
    const [downloadTypeModal, setDownloadTypeModal] = useState({ open: false, assignmentId: null, includeTbg: false });
    const  { fetchClassGameActivity } = useClassGameActivity()
    const show_hiddenen = useMemo(() =>highlightConfig && highlightConfig['show_hidden'], [highlightConfig])
    const exams = useExams()
    const [activeSem, setActiveSem] = useState(currentSem);
    const [semesterSwitchLoading, setSemesterSwitchLoading] = useState(false);
    const { getSubmissionStatus } = useGradeBook()
    const sortExam = () => {
        if (exams) {
            return exams.sort((a, b) => {
                if (a.order > b.order) {
                    return 1
                }
                if (a.order < b.order) {
                    return -1
                }
                return 0
            })
        } else {
            return [];
        }
    }
    const [passwordViewerOpen, setPasswordViewerOpen] = useState(false);
    const [passwordViewerUser, setPasswordViewerUser] = useState(null);
    const [selectedUser, setSelectedUser] = useState({});
    const [semAssignment, setSemAssignment] = useState(() => getDefaultAssignmentData(parentOrgId));
    const [activeSemData, setActiveSemData] = useState(new Array(8).fill({}, 0, 8));
    const scale_1_5 = userPreference?.gradePref == "scale_1_5"
    const gradebook_a_f = userPreference?.gradePref == "gradebook_a_f"
    const [activeGradeTab, setActiveGradeTab] = useState("")
    const [examSelectedClassId, setExamSelectedClassId] = useState(null);
    const isSchoologyUser = !!(currentUser && currentUser.schoologyid)
    const isGoogleClassroomUser = !!(currentUser && currentUser.googleId);
    const isCleverUser = !!(currentUser && currentUser.cleverId);
    const isCanvasUser = !!(currentUser && currentUser.canvas_id);
    const isGoogleUser = !!(currentUser && currentUser.googleId);
    const isClassLinkuser = !!(currentUser && currentUser.classlinkid);
    const isUserFromOtherPlatform =  isSchoologyUser || isCleverUser || isGoogleUser || isClassLinkuser || isCanvasUser
    const [listStudentUser, setListStudentUser] = useState(users && users.length > 0 ? filter(users, x => studentMatchesGradebookActiveFilter(x, 'active')).sort(sortname) : new Array(1).fill({}, 0, 1))
    const [deleteClassAssignmentToggle, setDeleteClassAssignmentToggle] = useState(false);
    const [assignmentData, setAssignmentData] = useState(null)
    const [deleteAssignmentLoading, setSeleteAssignmentLoading] = useState(false);
    const [nameShortType, setNameShortType] = useState(NAME_SHORTING[0]);
    const [studentSearchBy, setStudentSearchBy] = useState("full_name");
    const [studentSearchQuery, setStudentSearchQuery] = useState("");
    const [assignmentSearchQuery, setAssignmentSearchQuery] = useState("");
    const SEARCH_DEBOUNCE_MS = 300;
    const debouncedSetAssignmentSearchQuery = useMemo(
        () => debounce((value) => setAssignmentSearchQuery(value), SEARCH_DEBOUNCE_MS),
        []
    );
    const debouncedSetStudentSearchQuery = useMemo(
        () => debounce((value) => setStudentSearchQuery(value), SEARCH_DEBOUNCE_MS),
        []
    );
    const [gradeTableDateRangeLocal, setGradeTableDateRangeLocal] = useState(() => getDefaultGradeTableDateRange(activeSem, parentOrgId));
    const gradeTableDateRange = gradeTableDateRangeProp != null ? gradeTableDateRangeProp : gradeTableDateRangeLocal;
    const setGradeTableDateRange = onGradeTableDateRangeChange || setGradeTableDateRangeLocal;
    const isDateRangeControlled = gradeTableDateRangeProp != null && onGradeTableDateRangeChange;
    const videos = useVideos()
    const resources = useResources();
    const userAllowedBooks = useUserAllowedBooks()
    const [schoologyAssignment, listSchoologyAssignment] = useSchoologyAssignment()
    const [activeIndex, setActiveIndex] = useState(-1)
    const [deletingColumIndex, setDeletingColumIndex] = useState(-1)
    const inputRefs = useRef([]);
    const inputCells = useRef([]);
    const inputRowCells = useRef([]);
    const nameCellRefs = useRef([]);
    const studentSearchInputRef = useRef(null);
    const assignmentSearchInputRef = useRef(null);
    const activeCellIndexRefs = useRef(-1);
    const previousActiveIndexRef = useRef(-1);
    const [loginAsUserId,setLoginAsUserId] = useState(null);
    const [parentLoginUser, setParentLoginUser] = useState(null);
    const [loginasLoader,setLoginasLoader] = useState(false);
    const [loginAsParentModal, setLoginAsParentModal]  = useState(false);
    const [loginAsParentLoader, setLoginAsParentLoader] = useState(false);
    const [loginAsModal,setLoginAsModal] = useState(false);
    const [maxPoint, setMaxPoint] = useState(0);
    const [reportIssueModal, setReportIssueModal] = useState({ open: false, studentId: null, studentName: '' });
    const [studentDiffModalOpen, setStudentDiffModalOpen] = useState(false);
    const [studentDiffInitialIds, setStudentDiffInitialIds] = useState([]);
    const { socketConnection, reCreateSocket } = useSocket();
    const filterClassUsers = filter(classUsers, (user) => user?.role !== 'teacher' && user?.active === true).map(user => user.id);
    const studentSubmissionsRef = useRef(groupBy(submissions, 'userId')||{})
    const studentSubmissionLookup = useMemo(() => {
        const lookup = {};
        submissions.forEach((submission) => {
            const userId = submission?.userId;
            const assignmentId = submission?.assignmentId;
            if (!userId || assignmentId == null) return;
            if (!lookup[userId]) {
                lookup[userId] = {};
            }
            lookup[userId][String(assignmentId)] = submission;
        });
        return lookup;
    }, [submissions]);
    let CountSemester = 0
    const allowed_books = useCurrentClassBook();
    const orderedActiveSemData = useMemo(() => {
        let blankData, validData;
        if (userPreference?.order_by_date === 'due_date') {
            blankData = activeSemData.filter(k => !k.dueDate);
            validData = activeSemData.filter(k => k.dueDate);
        } else if (userPreference?.order_by_date === 'late_submission') {
            blankData = activeSemData.filter(k => !k.lateDate && !k.dueDate);
            validData = activeSemData.filter(k => k.lateDate || k.dueDate);
        } else {
            blankData = activeSemData.filter(k => !k.scheduleAt);
            validData = activeSemData.filter(k => k.scheduleAt);
        }
        const rangeBounds = getDateOnlyRangeBounds(gradeTableDateRange);
        if (rangeBounds) {
            const startMs = rangeBounds.start.getTime();
            const endMs = rangeBounds.end.getTime();
            const orderByDate = userPreference?.order_by_date;
            validData = validData.filter(item => {
                const d = new Date(getGradebookOrderDateValue(item, orderByDate));
                const t = d.getTime();
                return t >= startMs && t <= endMs;
            });
        }
        const orderByDatePref = userPreference?.order_by_date;
        let orderedData = lodashOrderBy(
            validData,
            [item => getGradebookOrderDaySortValue(item, orderByDatePref), item => getGradebookAssignmentSequence(item)],
            [orderBy, 'asc']
        );
        const appendBlank = !rangeBounds ? blankData : [];
        if (show_hiddenen) {
            orderedData = orderedData.filter(k => k.is_hidden);
            const total_len = orderedData.length + appendBlank.length;
            let blank_data = [];
            if (total_len < 8) {
                blank_data = Array.from({ length: 8 - total_len }, () => ({}));
            }
            return [...orderedData, ...appendBlank, ...blank_data];
        } else {
            orderedData = orderedData.filter(k => !k.is_hidden);
            const total_len = orderedData.length + appendBlank.length;
            let blank_data = [];
            if (total_len < 8) {
                blank_data = Array.from({ length: 8 - total_len }, () => ({}));
            }
            return [...orderedData, ...appendBlank, ...blank_data];
        }
    }, [orderBy, activeSemData, userPreference, show_hiddenen, gradeTableDateRange]);
    const getAssignmentSearchTarget = useCallback((assignment) => {
        if (!assignment?.id) return "";
        return get(assignment, "displayName", get(assignment, "data.displayName", ""));
    }, []);
    const displayedActiveSemData = useMemo(() => {
        const query = assignmentSearchQuery.trim().toLowerCase();
        const rows = query
            ? orderedActiveSemData.filter((assignment) => {
                if (!assignment?.id) return false;
                return getAssignmentSearchTarget(assignment).toLowerCase().includes(query);
            })
            : orderedActiveSemData;
        if (rows.length >= MIN_GRADE_TABLE_COLUMNS) {
            return rows;
        }
        const emptyCells = Array.from({ length: MIN_GRADE_TABLE_COLUMNS - rows.length }, () => ({}));
        return [...rows, ...emptyCells];
    }, [orderedActiveSemData, assignmentSearchQuery, getAssignmentSearchTarget]);
    const activeSemOederedUnhiddentAssignment = useMemo(() => {
        let blankData, validData;
        if (userPreference?.order_by_date === 'due_date') {
            blankData = activeSemData.filter(k => !k.dueDate);
            validData = activeSemData.filter(k => k.dueDate);
        } else if (userPreference?.order_by_date === 'late_submission') {
            blankData = activeSemData.filter(k => !k.lateDate && !k.dueDate);
            validData = activeSemData.filter(k => k.lateDate || k.dueDate);
        } else {
            blankData = activeSemData.filter(k => !k.scheduleAt);
            validData = activeSemData.filter(k => k.scheduleAt);
        }
        const rangeBounds = getDateOnlyRangeBounds(gradeTableDateRange);
        if (rangeBounds) {
            const startMs = rangeBounds.start.getTime();
            const endMs = rangeBounds.end.getTime();
            const orderByDate = userPreference?.order_by_date;
            validData = validData.filter(item => {
                const d = new Date(getGradebookOrderDateValue(item, orderByDate));
                const t = d.getTime();
                return t >= startMs && t <= endMs;
            });
        }
        const orderByDatePref = userPreference?.order_by_date;
        let orderedData = lodashOrderBy(
            validData,
            [item => getGradebookOrderDaySortValue(item, orderByDatePref), item => getGradebookAssignmentSequence(item)],
            [orderBy, 'asc']
        );
        orderedData = orderedData.filter(k => !k.is_hidden);
        const appendBlank = !rangeBounds ? blankData : [];
        const total_len = orderedData.length + appendBlank.length;
        let blank_data = [];
        if (total_len < 8) {
            blank_data = Array.from({ length: 8 - total_len }, () => ({}));
        }
        return [...orderedData, ...appendBlank, ...blank_data];
    }, [orderBy, activeSemData, userPreference, highlightConfig, gradeTableDateRange]);
    const numRows = useMemo(() => listStudentUser.length, [listStudentUser]);
    const numCols = useMemo(() => displayedActiveSemData.length, [displayedActiveSemData]);
    const hasDisplayedAssignments = useMemo(
        () => displayedActiveSemData.some((assignment) => assignment?.id),
        [displayedActiveSemData]
    );
    const showAssignmentSearchEmpty = useMemo(
        () => Boolean(assignmentSearchQuery.trim() && !hasDisplayedAssignments),
        [assignmentSearchQuery, hasDisplayedAssignments]
    );
    const assignmentSearchEmptyMinHeight = useMemo(() => {
        const headerRows = 90;
        const studentRows = Math.max(listStudentUser.length, 1) * 60;
        return headerRows + studentRows;
    }, [listStudentUser.length]);
    const sortByName = (a, b) => {
        const sortingFunctions = {
          [NAME_SHORTING[0].key]: (nameA, nameB, fallbackA, fallbackB) => {
            const result = nameA.localeCompare(nameB, 'en', { sensitivity: 'base' });
            return result !== 0 ? result : fallbackA.localeCompare(fallbackB, 'en', { sensitivity: 'base' });
          },
          [NAME_SHORTING[1].key]: (nameA, nameB, fallbackA, fallbackB) => {
            const result = nameB.localeCompare(nameA, 'en', { sensitivity: 'base' });
            return result !== 0 ? result : fallbackB.localeCompare(fallbackA, 'en', { sensitivity: 'base' });
          },
          [NAME_SHORTING[2].key]: (nameA, nameB, fallbackA, fallbackB) => {
            const result = nameA.localeCompare(nameB, 'en', { sensitivity: 'base' });
            return result !== 0 ? result : fallbackA.localeCompare(fallbackB, 'en', { sensitivity: 'base' });
          },
          [NAME_SHORTING[3].key]: (nameA, nameB, fallbackA, fallbackB) => {
            const result = nameB.localeCompare(nameA, 'en', { sensitivity: 'base' });
            return result !== 0 ? result : fallbackB.localeCompare(fallbackA, 'en', { sensitivity: 'base' });
          }
        };
      
        // Determine whether to sort by firstName or lastName
        const getKey = (type) => {
          return (type === NAME_SHORTING[2].key || type === NAME_SHORTING[3].key) ? 'firstName' : 'lastName';
        };
      
        const primaryKey = getKey(nameShortType.key);
        const secondaryKey = primaryKey === 'firstName' ? 'lastName' : 'firstName';
      
        const getNormalizedString = (obj, key) => {
          // Normalizing the key (firstName or lastName)
          return obj[key].toLowerCase().replace(/\s/g, "");
        };
      
        const primaryA = getNormalizedString(a, primaryKey);
        const primaryB = getNormalizedString(b, primaryKey);
        const secondaryA = getNormalizedString(a, secondaryKey);
        const secondaryB = getNormalizedString(b, secondaryKey);
        
      
        // Use the appropriate sorting function
        return sortingFunctions[nameShortType.key](primaryA, primaryB, secondaryA, secondaryB);
      };
      
    const getUserName = (usr) => {
        if (!usr || !has(usr, "firstName")) return "";

        const firstName = get(usr, "firstName", "");
        const lastName = get(usr, "lastName", "");

        if (nameShortType.key === NAME_SHORTING[2].key || nameShortType.key === NAME_SHORTING[3].key) {
            return `${firstName}, ${lastName}`;
        }

        return `${lastName}, ${firstName}`;
    };
    useEffect(() => {
        return () => {
            debouncedSetAssignmentSearchQuery.cancel();
            debouncedSetStudentSearchQuery.cancel();
        };
    }, [debouncedSetAssignmentSearchQuery, debouncedSetStudentSearchQuery]);

    useEffect(() => {
        const allstudents = uniqBy(filter(users, x => x.role === 'student').sort(sortByName), "username");
        const viewStudents = allstudents.filter((u) => studentMatchesGradebookActiveFilter(u, activeInactive));
        const searchedStudents = studentSearchQuery.trim()
            ? viewStudents.filter((student) => getStudentSearchTarget(student).toLowerCase().includes(studentSearchQuery.trim().toLowerCase()))
            : viewStudents;
        const finalList = searchedStudents.length > 0 ? searchedStudents : [];
        setListStudentUser(finalList);
    }, [users, activeInactive, nameShortType, studentSearchBy, studentSearchQuery])
    useEffect(() => {
       activeCellIndexRefs.current = activeIndex;
    }, [activeIndex])

    useEffect(() => {
        const toShowSemObj = SemesterToShow(parentOrgId);
        
        if (!classActivities || !classQuizzes) return;
    
        const uniqueActivity = uniqBy(classActivities, "activityId");
        const uniqueQuiz = uniqBy(classQuizzes, 'quizId');
        let _assignments = [...uniqueActivity, ...uniqueQuiz].filter(k => {
            const type = get(k, "type", "");
            return isBookAllowed(userAllowedBooks?.other_permissions?.resourses, k, type, allowed_books);
        })
    
        const _sortedAssignments = _assignments.slice().sort((a, b) => moment(a.dueDate).diff(b.dueDate));
        
        let semData = {};
        const isSpecial = parentOrgId && ['e5dcb06f-f78d-457a-bacf-8fa357b38ee2', '37ae9554-0da4-4d62-b04f-ec500b0275a4'].includes(parentOrgId);
        
        _sortedAssignments.forEach(assignment => {
            const assignmentDate = moment(assignment.dueDate);
            const assignmentYear = assignmentDate.year();
            const assignmentMonth = assignmentDate.month();
            const assignmentDay = assignmentDate.date();
            
            let sem1Year, sem2Year;
            let sem1StartDate, sem1EndDate, sem2StartDate, sem2EndDate;
            
            if (isSpecial) {
                const sem1EndDay = getSem1EndDate(parentOrgId);
                const sem2StartDay = getSem2StartDate(parentOrgId);
                if (assignmentMonth === 0 && assignmentDay <= sem1EndDay) {
                    sem1Year = assignmentYear - 1;
                    sem2Year = assignmentYear;
                    const sem1Dates = semeterDateByYear(sem1Year, parentOrgId);
                    const sem2Dates = semeterDateByYear(sem2Year, parentOrgId);
                    sem1StartDate = sem1Dates.sem1StartDate;
                    sem1EndDate = sem1Dates.sem1EndDate;
                    sem2StartDate = sem2Dates.sem2StartDate;
                    sem2EndDate = sem2Dates.sem2EndDate;
                } else if (assignmentMonth === 0 && assignmentDay >= sem2StartDay) {
                    sem1Year = assignmentYear - 1;
                    sem2Year = assignmentYear;
                    const sem1Dates = semeterDateByYear(sem1Year, parentOrgId);
                    const sem2Dates = semeterDateByYear(sem2Year, parentOrgId);
                    sem1StartDate = sem1Dates.sem1StartDate;
                    sem1EndDate = sem1Dates.sem1EndDate;
                    sem2StartDate = sem2Dates.sem2StartDate;
                    sem2EndDate = sem2Dates.sem2EndDate;
                } else if (assignmentMonth >= 6) {
                    sem1Year = assignmentYear;
                    sem2Year = assignmentYear;
                    const sem1Dates = semeterDateByYear(sem1Year, parentOrgId);
                    const sem2Dates = semeterDateByYear(sem2Year, parentOrgId);
                    sem1StartDate = sem1Dates.sem1StartDate;
                    sem1EndDate = sem1Dates.sem1EndDate;
                    sem2StartDate = sem2Dates.sem2StartDate;
                    sem2EndDate = sem2Dates.sem2EndDate;
                } else {
                    sem1Year = assignmentYear - 1;
                    sem2Year = assignmentYear;
                    const sem1Dates = semeterDateByYear(sem1Year, parentOrgId);
                    const sem2Dates = semeterDateByYear(sem2Year, parentOrgId);
                    sem1StartDate = sem1Dates.sem1StartDate;
                    sem1EndDate = sem1Dates.sem1EndDate;
                    sem2StartDate = sem2Dates.sem2StartDate;
                    sem2EndDate = sem2Dates.sem2EndDate;
                }
            } else {
                sem1Year = assignmentYear;
                sem2Year = assignmentYear;
                const dates = semeterDateByYear(assignmentYear, parentOrgId);
                sem1StartDate = dates.sem1StartDate;
                sem1EndDate = dates.sem1EndDate;
                sem2StartDate = dates.sem2StartDate;
                sem2EndDate = dates.sem2EndDate;
            }
            
            let sem1 = semData[getKey(1, sem1Year.toString())] || [];
            let sem2 = semData[getKey(2, sem2Year.toString())] || [];
    
            if (assignmentDate.isBetween(sem1StartDate, sem1EndDate, 'day', '[]')) {
                sem1.push(assignment);
            } else if (assignmentDate.isBetween(sem2StartDate, sem2EndDate, 'day', '[]')) {
                sem2.push(assignment);
            }
            
            semData[getKey(1, sem1Year.toString())] = sem1;
            semData[getKey(2, sem2Year.toString())] = sem2;
        });
         Object.keys(semData).forEach(key=>{
            if (semData[key] !== undefined && semData[key].length < 8) {
                const len = 8 - semData[key].length;
                const arr = Array.from({ length: len }, () => ({}));
                semData[key] = semData[key].concat(arr);
              }
         })
        const activeSemData = semData[activeSem] || new Array(8).fill({}, 0, 8);
        setActiveSemData(activeSemData);
    
        const tempSemData = {};
        Object.keys(toShowSemObj).forEach(key => {
            const dt = semData[toShowSemObj[key]] || new Array(8).fill({}, 0, 8);
            tempSemData[toShowSemObj[key]] = dt;
        });
        setSemAssignment(tempSemData);
    }, [classActivities, classQuizzes, currentClass, activeSem, parentOrgId]);
    
    useEffect(() => {
        getPref()
        getGradesFromScoology()
        getAssignmentFromSchoology()
    }, [classActivities, classQuizzes])
    const getPref = async () => {
        await dispatch(handleGetUserPreference(currentUser?.id));

    }
    useEffect(() => {
        setCurrentSem(currentSem == activeSem)
    }, [activeSem, currentSem])

    useEffect(() => {
        if (!onGradeTableDateRangeChange) {
            setGradeTableDateRangeLocal(getDefaultGradeTableDateRange(activeSem, parentOrgId));
        }
    }, [activeSem, parentOrgId, onGradeTableDateRangeChange]);
    const PopPupExam = (msg) => {
        showAlert(msg, 'error')
    }
    const isStoryAssignment = useCallback((bkId) =>find(story,k=>k.bookId ==  bkId),[story])
    
    const getAssignmentProperties = useCallback((assignment) => {
        const assignmentType = get(assignment, "type")
        const is_game = assignmentType === 'game'
        const is_debate = assignmentType === 'debate'
        const is_worksheet = assignmentType === 'worksheet'
        const is_loteria = assignmentType === 'bingo'
        const chapter = is_game || is_loteria ? assignment.bookId : assignment?.data?.chapter
        const isStory = isStoryAssignment(chapter)
        
        let cell_style = {}
        if (is_game) {
            cell_style = { backgroundColor: COLOR.sky200 }
        } else if (is_debate || is_loteria) {
            cell_style = { backgroundColor: COLOR.tabActive }
        }
        
        if (isStory && !is_debate) {
            cell_style = { backgroundColor: COLOR.indigo600 }
        }
        
        if (is_worksheet) {
            cell_style = { backgroundColor: COLOR.indigo400 }
        }
        
        return {
            isActive: get(assignment, "active", true),
            disabled: !get(assignment, "id"),
            is_game,
            is_debate,
            is_worksheet,
            is_loteria,
            chapter,
            isStory,
            cell_style
        }
    }, [isStoryAssignment])
    
    const enterKeyListner = useCallback(() => {
        try {
            const hasref = inputRefs.current.find(e => e && e.ref == document.activeElement)
            const active_index = activeCellIndexRefs.current;
            const currentInput = inputRefs.current[active_index]
            if (hasref) {
                if (active_index < numRows * numCols - numCols) {
                    onBlurInput()
                    setActiveIndex(active_index + numCols);
                } else {
                    onBlurInput()
                }
            } else {
                if (currentInput && currentInput.ref.disabled) {
                    if (active_index < numRows * numCols - numCols) {
                        setActiveIndex(active_index + numCols);
                    }
                } else {
                    onFousInput(active_index);
                }
            }  
        } catch (error) {
            Sentry.captureException(`529 Error in enterKeyListner: ${error}`);
          console.error(error,"error on enter key listen");  
        }
    }, [numRows, numCols])
    const handleKeyDown = useCallback(
        (e) => {
            let debateInput = document.getElementsByClassName("left-right-disabled").length > 0;
            if(document.querySelector('.ant-drawer-open')||document.querySelector('.one_game_open') || debateInput) return;
            const { key } = e;
            const row = Math.floor(activeIndex / numCols);
            const StartRow = row * numCols;
            const EndRow = StartRow + numCols;
            switch (key) {
                case "ArrowUp":
                case 38:
                    if (activeIndex / numCols >= 1) {
                        onBlurInput()
                        setActiveIndex(activeIndex - numCols);
                        // onFousInput(activeIndex - numCols);
                    }
                    break;
                case "ArrowDown":
                case 40:
                    // Move down a row, add num cols to index
                    if (activeIndex < numRows * numCols - numCols) {
                        onBlurInput()
                        setActiveIndex(activeIndex + numCols);
                        // onFousInput(activeIndex + numCols);
                    }
                    break;
                case "ArrowRight":
                case 39:
                    if (activeIndex < (EndRow-1)) {
                        setActiveIndex(activeIndex + 1);
                        onBlurInput()
                        // onFousInput(activeIndex + 1);
                    }
                    break;
                case "ArrowLeft":
                case 37:
                    if (activeIndex > StartRow) {
                        setActiveIndex(activeIndex - 1);
                        onBlurInput()
                        // onFousInput(activeIndex - 1);
                    }
                    break;
                case "Enter":
                case 13:
                    enterKeyListner()
                    break;
                case "Escape":
                    onBlurInput()
                    break;
                default:
                    break;
            }
        },
        [activeIndex, numRows, numCols]
    );

    const onFousInput = (index) => {
        onBlurInput()
        const inputRef = inputRefs.current[index];
        if (inputRef) {
            inputRef.focus();
        }
    }
    const onBlurInput = () => {
        document.activeElement.blur();
    }
    useEffect(() => {
        window.addEventListener("keydown", handleKeyDown);
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [handleKeyDown]);
  
    const updateSubmission = async (subm) => {
        if (!subm || !subm.userId) return;
        await dispatch(handleUpdateSubmission(subm?.id, subm, subm))
    }
    const getGradesFromScoology = debounce(async () => {
        try {
            if (currentClass?.sectionId) {
                await handleSyncSchoologyClassesGrades(currentUser.id, currentClass.id);
                // await handleSyncGradesToSchoology(currentUser.id, currentClass.id)
                await dispatch(handleListClassSubmissions(currentClass?.id))
            }

        } catch (error) {
            console.log(error, "bid-err");
            Sentry.captureException(`530 Error in getGradesFromScoology: ${error}`);
        }

    },1000)
    const location = useLocation();
  	const navigate = useNavigate();
    const bookUnits = useBookUnits()

    const generateUrl = (CHAPTER_ID, page, activity, quiz) => {
        const storyUrl = getStoryUrl(story, CHAPTER_ID, page, quiz, activity)
        const backToLabel = BACK_TO_BOOK[CHAPTER_ID]
        const BALCON_PAGES = get(find(bookUnits, ["bookId", CHAPTER_ID]), "pages", [])
        const bookitem = find(BALCON_PAGES, k => parseInt(k.start) <= page && parseInt(k.finish) >= page)
        const url = generateUrlForNonEbook(bookitem?.id, page, activity, quiz, backToLabel, null, CHAPTER_ID)
        if (url && backToLabel) {
            return url;
        }
        else if (storyUrl) {
            return storyUrl;
        } else {
            return null;
        }
    }
    const goToBook = (chapter, pageId) => {
        const generatedUrl = generateUrl(chapter,pageId, null, null) 
        if (isVideo(chapter, resources)) {
            navigate(`/video?id=${chapter}&quiz=null`);
        } else if (generatedUrl){
            navigate(generatedUrl);
        }
        else {
            navigate(`/ebook?chapter=${chapter}&page=${pageId}&activity=null&quiz=null`);
        }
    }
    const syncToCanvas = async (assignmentId) => {
        message.loading("Syncing grade to canvas...");
       const response = await  handleSyncTOCanvas(currentUser.canvas_id, currentUser.canvas_auth_id, assignmentId)
       if (response?.is_new_create) {
        await Promise.all([
            dispatch(handleListClassActivities(currentClass?.id)),
            dispatch(handleListClassQuizzes(currentClass?.id))
        ])
        message.success("Grade synced to canvas successfully");
       }
    }
    const syncFromCanvas = async (assignmentId) => {
       await handleSyncFromCanvas(currentUser.canvas_id, currentUser.canvas_auth_id, assignmentId)
       await dispatch(handleListClassSubmissions(currentClass?.id))
    };
    const syncToSchoology = async (assignmentId) => {
        await  handleSyncGradeToSchoologyByAssignment(currentUser.schoologyid, assignmentId)
    }
    const syncFromSchoology = async (assignmentId) => {
       await handleSyncGradeFromSchoologyByAssignment(currentUser.schoologyid, assignmentId)
       await dispatch(handleListClassSubmissions(currentClass?.id))
    };
    const isDueDatePassed = (assignment) => {
        if (!assignment) return false;
        return  assignment.lateDate ? isBeforTime(assignment.lateDate) : isBeforTime(assignment.dueDate);
    };
    const onSubmissionsReturn = (assignment) => {
        const submissionData = []
        if (isDueDatePassed(assignment)) {
            showAlert(`You can’t return this assignment because it is already past due. Please change the due date if you’d like to return the submission.`, 'error')
            return;
        }
        map(listStudentUser, usr => {
            const submission = studentSubmissionsRef.current[usr.id] || []
            const userSubmission = submission.find(sub => sub.assignmentId === assignment?.data?.id)
            if (userSubmission) {
                if (!userSubmission.complete || (userSubmission.returned === userSubmission.submissions + 1) || userSubmission.exceptionStatus>0) return;
                submissionData.push({
                    userId: usr.id,
                    assignmentId: assignment.data.id,
                    submission_id: userSubmission.id,
                    firstName: usr.firstName,
                    lastName: usr.lastName,
                    submission: userSubmission,
                })
            }
        });
        if (submissionData.length > 0) {
            setReturnSubmission({
                open: true,
                submissionList: submissionData
            });
        }else{
            showAlert("No submission found to return", 'error')
        }
    }
    const syncToGoogleClassroom = async (assignmentId) => {
        try {
            setLoginAsParentLoader(true)
            message.loading("Syncing grade to google classroom...");
            const response = await handleSyncAssignmentGradeToGoogleClassroom(currentUser.googleId, assignmentId, currentClass.gradeCategoryId)
            if (response?.success) {
                if(response.data.assignment_created) {
                    await Promise.all([
                        dispatch(handleListClassActivities(currentClass?.id)),
                        dispatch(handleListClassQuizzes(currentClass?.id))
                    ])
                }
                showAlert("Grade synced to google classroom successfully", 'success')
            } else {
                showAlert("Error syncing grade to google classroom", 'error')
                Sentry.captureException(`537 Error in syncToGoogleClassroom: ${response?.error}`);
            }
        } catch (error) {
            showAlert("Error syncing grade to google classroom", 'error')
            Sentry.captureException(`537 Error in syncToGoogleClassroom: ${error}`);
        } finally {
            setLoginAsParentLoader(false)
        }
    }
    const booknav = (assignment, is_game , is_debate  , col_index) => {
        const isActive = get(assignment, "active", true)
        const is_hidden = get(assignment, "is_hidden", false)
        const isUngraded = get(assignment, "ungraded", false)
        const onClickPopulateGrade = () => {
            const max_point = assignment?.max_point && !isNaN(assignment?.max_point) ? Number.parseInt(assignment.max_point, 10) : 100
            setMaxPoint(max_point)
            setGradePopulateModal(true)
            setSelectedPopulateAssignment(assignment);
        }
        if (is_game) {
            const items = [];
            if (!is_debate) {
                items.push({
                    key: 'go-to-book',
                    label: (
                        <PaddedBtn onClick={() => {
                            goToBook(assignment.bookId||assignment.chapter, assignment.pageId||assignment.page)
                        }}>
                            Go to book
                        </PaddedBtn>
                    )
                });
            }
            items.push(
                {
                    key: 'delete',
                    label: (
                        <PaddedBtn onClick={() => {
                            if (assignment && Object.keys(assignment).length > 0) {
                                setDeleteClassAssignmentToggle(true)
                                setAssignmentData(assignment)
                                setDeletingColumIndex(col_index)
                            }
                        }}>
                            Delete
                        </PaddedBtn>
                    )
                },
                {
                    key: 'hide-show',
                    label: (
                        <PaddedBtn style={{ color: !is_hidden ? COLOR.black : COLOR.red }}
                            onClick={() => {
                                setHideConfirmationData({ assignment, is_hidden, sub_type: 'game' });
                                setShowHideConfirmationModal(true);
                            }}>
                            {!is_hidden ? "Hide" : "Show"}
                        </PaddedBtn>
                    )
                }
            );
            if (!isUngraded) {
                items.push({
                    key: 'populate-grade',
                    label: (
                        <PaddedBtn
                            onClick={onClickPopulateGrade}>
                            Populate the grade
                        </PaddedBtn>
                    )
                });
            }
            
            items.push({
                key: 'download',
                label: (
                    <PaddedBtn
                        onClick={() => {
                            const assignmentType = get(assignment, "type");
                            const is_loteria = assignmentType === 'bingo';
                            const is_worksheet = assignmentType === 'worksheet';
                            const assignmentId = is_game || is_debate || is_loteria || is_worksheet ? assignment.session_id : assignment?.data?.id || assignment?.id;
                            setDownloadTypeModal({ open: true, assignmentId });
                        }}>
                        Download
                    </PaddedBtn>
                )
            });
            
            return items;
        }
        
        const items = [
            {
                key: 'edit',
                label: (
                    <PaddedBtn onClick={() => {
                        if (assignment?.quizId) {
                            handleEditQuiz(assignment)
                        } else if (assignment.activityId) {
                            handleEditActivity(assignment)
                        }
                    }}>
                        Edit
                    </PaddedBtn>
                )
            },
            {
                key: 'go-to-book',
                label: (
                    <PaddedBtn onClick={() => {
                        goToBook(get(assignment, "data.chapter"), get(assignment, "data.page"))
                    }}>
                        Go to book
                    </PaddedBtn>
                )
            },
            {
                key: 'delete',
                label: (
                    <PaddedBtn onClick={() => {
                        if (assignment && Object.keys(assignment).length > 0) {
                            setDeleteClassAssignmentToggle(true)
                            setAssignmentData(assignment)
                        }
                    }}>
                        Delete
                    </PaddedBtn>
                )
            },
            {
                key: 'activate-deactivate',
                label: (
                    <PaddedBtn style={{ color: isActive ? COLOR.black : COLOR.red }}
                        onClick={() => {
                            if (get(assignment, "data.typeId") == "quiz" || get(assignment, "data.typeId") === "quizresource") {
                                activeDeactiveQuizzes(get(assignment, "id"), !isActive)
                            } else {
                                activeDeactiveActivites(get(assignment, "id"), !isActive)
                            }
                        }}>
                        {isActive ? "Deactivate" : "Activate"}
                    </PaddedBtn>
                )
            },
            {
                key: 'hide-show',
                label: (
                    <PaddedBtn style={{ color: !is_hidden ? COLOR.black : COLOR.red }}
                        onClick={() => {
                            setHideConfirmationData({ assignment, is_hidden, sub_type: null });
                            setShowHideConfirmationModal(true);
                        }}>
                        {!is_hidden ? "Hide" : "Show"}
                    </PaddedBtn>
                )
            },
            {
                key: 'deactivate-student',
                label: (
                    <PaddedBtn 
                        onClick={() => setDectivateByStudent({open: true, assignmentData: assignment })}>
                         Deactivate for student
                    </PaddedBtn>
                )
            },
            {
                key: 'return-submission',
                label: (
                    <PaddedBtn 
                        onClick={() => onSubmissionsReturn(assignment)}>
                         Return submission for student
                    </PaddedBtn>
                )
            }
        ];
        
        if (!isUngraded) {
            items.push({
                key: 'populate-grade',
                label: (
                    <PaddedBtn
                        onClick={() => {
                            onClickPopulateGrade()
                        }}>
                        Populate the grade
                    </PaddedBtn>
                )
            });
        }
        
        items.push({
            key: 'download',
            label: (
                <PaddedBtn
                    onClick={() => {
                        const assignmentId = assignment?.data?.id || assignment?.id || assignment?.quizId || assignment?.activityId;
                        setDownloadTypeModal({ open: true, assignmentId });
                    }}>
                    Download
                </PaddedBtn>
            )
        });
        
        if (isCanvasUser) {
            items.push(
                {
                    key: 'sync-to-canvas',
                    label: (
                        <PaddedBtn
                            onClick={() => {
                                syncToCanvas(assignment.id)
                            }}>
                            Sync grade to canvas
                        </PaddedBtn>
                    )
                },
                {
                    key: 'sync-from-canvas',
                    label: (
                        <PaddedBtn
                            onClick={() => {
                               syncFromCanvas(assignment.id)
                            }}>
                            Sync grade from canvas
                        </PaddedBtn>
                    )
                }
            );
        }
        
        if (isSchoologyUser) {
            items.push(
                {
                    key: 'sync-to-schoology',
                    label: (
                        <PaddedBtn
                            onClick={() => {
                                syncToSchoology(assignment.id)
                            }}>
                            Sync grade to schoology
                        </PaddedBtn>
                    )
                },
                {
                    key: 'sync-from-schoology',
                    label: (
                        <PaddedBtn
                            onClick={() => {
                                syncFromSchoology(assignment.id)
                            }}>
                            Sync grade from schoology
                        </PaddedBtn>
                    )
                }
            );
        }

        if (isGoogleClassroomUser) {
            items.push(
                {
                    key: 'sync-to-google-classroom',
                    label: (
                        <PaddedBtn
                            onClick={() => {
                                syncToGoogleClassroom(assignment.id)
                            }}>
                            Sync grade to google classroom
                        </PaddedBtn>
                    )
                }
            );
        }
        return items;
    };

    const handleHideActivity = async (assignment, is_hidden, sub_type) => {
        const { typeId } = assignment?.data || {};
        const id = assignment?.id;
        
        const type = (() => {
            if (typeId === "quiz" || typeId === "quizresource") return "quiz";
            if (typeId === "activity") return "activity";
            return sub_type || "game";
        })();
    
        try {
             setAlertLoading(true, 'Updating status......');
            const response = await dispatch(handleHiddenStatusActivity(!is_hidden, id, type));
    
            if (response?.success) {
                 setAlertLoading(false, '')
                showAlert(!is_hidden ? "Hidden successfully" : "Unhidden successfully", 'success');
            } else {
                setAlertLoading(false, '')
                showAlert("Something went wrong", 'error')
            }
        } catch (error) {
            showAlert("Error occurred while updating status", 'error')
            console.error(error);
        }finally{
            setAlertLoading(false, '')
        }
    };
    const activeDeactiveQuizzes = async (id, active) => {
        await dispatch(handleChangeStatusQuizzes(id, active))
    }
    const activeDeactiveActivites = async (id, active) => {
        setAlertLoading(true, 'Updating status......');
        try {
            await dispatch(handleChangeStatusActivity(id, active))
            setAlertLoading(false, '')
            showAlert(active ? "Activated successfully" : "Deactivated successfully", 'success');
        } catch (error) {
            setAlertLoading(false, '')
            showAlert(error.message||'Something went wrong', 'error')
            Sentry.captureException(`531 Error in activeDeactiveActivites: ${error}`);
        }finally{
            setAlertLoading(false, '')
        }
    }
    const getAssignmentFromSchoology =async () => {
        try {
            if (currentClass?.sectionId) {
                await handleSyncAssignmentDataSchoology(currentClass.id, currentUser.schoologyid)
            }
        } catch (error) {
            Sentry.captureException(`532 Error in getAssignmentFromSchoology: ${error}`);
            console.log(error, "bid-err");
        }
    }
    const checkSchoologyAssignment = (assignment) => {
        if (!assignment?.sAssignmentId || !assignment) return null;
        const is_game = assignment.type === "debate" || assignment.type === "game" || assignment.type === "bingo" || assignment.type == "worksheet"
        const hasAssignment = find(schoologyAssignment, k => k.id == assignment?.sAssignmentId)
        return hasAssignment || is_game ? null : `Deleted from schoology!`
    }

    // if (students.length < 1) {
    //     let arr = new Array(1).fill({}, 0, 1)
    //     students.push(...arr)
    // }
    useEffect(()=>{
        studentSubmissionsRef.current =  groupBy(submissions, 'userId');
    },[submissions])
    const getWeightedGrade = (grade, weight) => {
        if (weight === 0) {
            return 0;
        }
        return (grade) * weight / 100;
    };
    const getWeightageFroQuiz = (assignment) => {
        return classQuizzes?.find(x => x.quizId === assignment.id)?.weightage
    }
    const getWeightageForActivity = (assignment) => {
        return classActivities?.find(x => x.activityId === assignment.id)?.weightage
    }
    const getWeightageForAssignment = useCallback((assignemnt) => {
        let weightage = 100;
        if (assignemnt.typeId === 'quiz') {
            let calculatedWeightage = getWeightageFroQuiz(assignemnt);
            if (!isNaN(calculatedWeightage) && calculatedWeightage > 0 && calculatedWeightage <= 100) {
                weightage = calculatedWeightage
            }
        } else {
            let calculatedWeightage = getWeightageForActivity(assignemnt);
            if (!isNaN(calculatedWeightage) && calculatedWeightage > 0 && calculatedWeightage <= 100) {
                weightage = calculatedWeightage
            }
        }
        return weightage;
    }, [classQuizzes, classActivities]) 
    const getSkipAssignment = (data) => {
        if(!isSchoologyUser) return data;
        for (const key in data) {
            if (data.hasOwnProperty(key) && Array.isArray(data[key])) {
                const drop_lowest = get(find(schoologyGradeCategory, k => k.id == key), "drop_lowest", 0)
                data[key].sort((a, b) => a.grade - b.grade);
                data[key].splice(0, drop_lowest);
            }
        }
        return data;
    }
    const getFactor = useCallback((assignment) => {
        if (!isSchoologyUser) return 1;
        try {
            if (assignment && assignment.assignment && Array.isArray(assignment.assignment.classes)) {
                const class_config = assignment.assignment.classes.find(k => k.id == currentClass.id)
                if (has(class_config, "factor")) {
                    const val = parseInt(class_config.factor);
                    if (val == 0) return 0;
                }
            }
        } catch (error) {
            Sentry.captureException(`Error in getting factor class id ${currentClass.id} , user id ${currentUser.id}`)
        }
        return 1;
    },[currentClass])
    const checkIsCompleteTbg = dt => {
        const questions = get(dt, "assignment.data.questions", [])
        if (Array.isArray(questions)) {
            return questions.some(k => k.type == "multipleChoice" || k.type == "trueFalse" || k.type == 'audioTrueFalse' || k.type == 'audioMultipleChoice' || k.type == 'multipleResponse')
        }
        return false;
    }
    const getStudentSubmissionByAssignmentId = useCallback((userId, assignmentId) => {
        if (!userId || assignmentId == null) return null;
        const assignmentKey = String(assignmentId);
        const lookupSubmission = studentSubmissionLookup?.[userId]?.[assignmentKey];
        if (lookupSubmission) {
            return lookupSubmission;
        }
        const fallbackSubmissions = studentSubmissionsRef.current[userId] || [];
        return find(fallbackSubmissions, ['assignmentId', assignmentId]) || null;
    }, [studentSubmissionLookup]);
    const calculateGrade = useCallback((userID) => {
        if (!userID) return "-";
        let numberOfAssignment = 0;
        let total = 0;
        const currentSemSubmitted = map(activeSemOederedUnhiddentAssignment, x => {
            if (!x || !x.classId) return null;
            const assignmentId = x.quizId || x.activityId;
            const sub = getStudentSubmissionByAssignmentId(userID, assignmentId);
            const schoologyCategory =  get(find(x.classes,["id",currentClass.id]),"schoologyCategory")
            return sub ? ({ ...sub, assignment: x , schoologyCategory }) : null;
        }).filter(k => k)
        const assignemtBySchoologyCategory = {}
        if(isSchoologyUser){
            map(currentSemSubmitted, x => {
                if( get(x,"assignment.ungraded")) return;
                if (!isNaN(x.grade) && !x.manualGrading) {
                    const grd = getWeightedGrade(parseInt(x.grade, 10), getWeightageForAssignment(x.assignment))
                    if(assignemtBySchoologyCategory[x.schoologyCategory]){                 
                        assignemtBySchoologyCategory[x.schoologyCategory].push({
                            assignemtId:x.assignment.id,
                            grade: x.exceptionStatus > 0 ? 0 : parseInt(grd, 10)
                        })
                    }else{
                        assignemtBySchoologyCategory[x.schoologyCategory] = [{
                            assignemtId:x.assignment.id,
                            grade: x.exceptionStatus > 0 ? 0 : parseInt(grd, 10)
                        }]
                    }
                }
            })
        }
        const skippedAssignment  = getSkipAssignment(assignemtBySchoologyCategory)
        map(currentSemSubmitted, (x,i) => {
            if( get(x,"assignment.ungraded")) return;
            const grade_type = get(x,"assignment.grade_type")
            const ispointsystem = grade_type === "points";
            const iscomplete_incomplete = grade_type === "complete_incomplete"
            const max_points = get(x,"assignment.max_point",100) || 100
            const has_multi = checkIsCompleteTbg(x)
            // const weightage = parseInt(get(x,"assignment.weightage","100") || "100",10)
            if(isSchoologyUser){
                const factor = getFactor(x);
                if(factor==0) return;
                const schoologyCategory = get(x,"schoologyCategory");
                const gradeAssignment  = skippedAssignment[schoologyCategory]
                const hasAssignment = find(gradeAssignment,k=>k.assignemtId == get(x,"assignment.id"))
                if(!hasAssignment) return;
            }
            if (x.exceptionStatus != 1 && x.exceptionStatus != 2 && x.exceptionStatus != 5 && x.exceptionStatus != 6 && (!x.manualGrading || (x.manualGrading && has_multi)) && x.complete && !isNaN(x.grade) && x.grade !== null) {
                numberOfAssignment++;
            }
            let granted_total = 0;
            if (x.grade !== null &&!isNaN(x.grade) && (!x.manualGrading||(x.manualGrading&&has_multi)) && x.complete) {
                if(ispointsystem){
                    const face_grade =  parseInt(get(x, "face_grade"), 10)
                    const max_value = parseInt(max_points, 10);
                    if(max_value > 0 && !isNaN(face_grade)){
                        let grd  = (face_grade / max_value ) * 100;
                        if (face_grade > max_value && max_value > 0) {
                            if (face_grade <= 100) {
                                grd = ((face_grade / 10) / max_value) * 100;
                            } else {
                                grd = max_value;
                            }
                        }

                            granted_total += x.exceptionStatus > 0 ? 0 : grd;                        }
                }else if(iscomplete_incomplete){
                      if(parseInt(x.grade, 10)>0){
                        // let grd = getWeightedGrade(100,weightage)
                        let grd = 100;
                        granted_total += x.exceptionStatus > 0 ? 0 : grd;
                      }
                }else{
                    // const grd = getWeightedGrade(parseInt(x.grade, 10), getWeightageForAssignment(x.assignment))
                    let grd = parseInt(x.grade, 10)
                    if (!isNaN(parseInt(grd, 10))) {
                        if (grd > 100) {
                            grd = 100;
                        }
                        granted_total += x.exceptionStatus > 0 ? 0 : grd;
                    }
                }
            }
            total+=granted_total;
        })
        const grade_val = (total / numberOfAssignment).toFixed(2);
        const grade = grade_val.endsWith('.00') ? grade_val.split('.')[0] : grade_val;
        // const grade = (parseInt(total, 10) / parseInt(numberOfAssignment, 10)).toFixed(0);
        let gradeMarks = grade;
        if (scale_1_5) {
            if (grade !== "NaN") {
                const g = grade <= 0 ? 0 : floor((grade - 1) / 20)
                gradeMarks = g > 4 ? 4 : g;
            }
            else {
                gradeMarks = "-";
            }
        }
        if (gradebook_a_f) {
            if (grade !== "NaN") {
                const g = parseInt(grade)
                if (g <= 20 && g >= 0) {
                    gradeMarks = 'F';
                }
                else if (g <= 40 && g >= 21) {
                    gradeMarks = 'D';
                }
                else if (g <= 60 && g >= 41) {
                    gradeMarks = 'C';
                }
                else if (g <= 80 && g >= 61) {
                    gradeMarks = 'B';
                }
                else if (g >= 80) {
                    gradeMarks = 'A';
                } else {
                    gradeMarks = '-'
                }

            }
            else {
                gradeMarks = "-";
            }
        }
        return gradeMarks !== "NaN" ? gradeMarks : '-';
    }, [submissions, activeSem, scale_1_5, classActivities, classQuizzes, activeSemData, gradebook_a_f,activeSemOederedUnhiddentAssignment, getStudentSubmissionByAssignmentId]);
    const averageGradeLookup = useMemo(() => {
        const gradeLookup = {};
        listStudentUser.forEach((user) => {
            if (!user?.id) return;
            gradeLookup[user.id] = calculateGrade(user.id);
        });
        return gradeLookup;
    }, [listStudentUser, calculateGrade]);

 const calculateValue = useMemo(() => (assignment, user) => {
  if (!user || !get(assignment, "id")) {
    return {
      value: "--",
      isTbg: false,
      isLate: false,
      manualGrading: false,
      completeTbg: false,
    };
  }

  const grade_type = assignment.grade_type;
  const type = assignment.type;
  const is_game = type == "game";
  const is_worksheet = type == "worksheet";
  const is_loteria = type == "bingo";
  const is_debate = type == "debate";
  const complete_incomplete = grade_type == "complete_incomplete";
  const point_system = grade_type == "points";
  const assignment_id = (is_game || is_loteria || is_debate || is_worksheet)
    ? assignment.session_id
    : get(assignment, "data.id");

  let isDiffStudent = false;
  if (Array.isArray(assignment.classes) && assignment.classes.length > 0) {
    const classConfig = find(assignment.classes, ['id', get(currentClass, "id")]);
    if (classConfig?.diff) {
      isDiffStudent = checkIsDiffForUser(classConfig, user.id);
    }
  }

  const hasAssigned = is_game || is_loteria || is_debate || is_worksheet
    ? true
    : !assignment.users || assignment.users.length == 0 || assignment.users.includes(user.id);

  const user_submission = getStudentSubmissionByAssignmentId(user.id, assignment_id);
  if (!user_submission) {
    return {
      value: null,
      isTbg: false,
      isLate: false,
      isDiffStudent,
      manualGrading: false,
      completeTbg: false,
      hasAssigned,
      is_game,
      face_grade: null,
      point_system,
      complete_incomplete,
      is_debate,
      is_loteria,
      is_worksheet,
    };
  }

  const isIncomplete = !user_submission.complete && user_submission.pastSubmissions?.length == 0;
  if (isIncomplete && !is_game && !is_debate && !is_loteria && !is_worksheet) {
    return {
      value: null,
      isTbg: false,
      isLate: false,
      isDiffStudent,
      manualGrading: false,
      completeTbg: false,
      hasAssigned,
      is_game,
      face_grade: null,
      point_system,
      complete_incomplete,
      is_debate,
      is_loteria,
      is_worksheet,
    };
  }

  const retaking = user_submission.retaking || false;
  const questions = get(user_submission, "assignment.questions", []) || [];
  const isTbg = checkIsManualGradable(questions);
  const isAllTab = checkHasAutoGrade(questions) && !isTbg;
  const manualGrading = user_submission.manualGrading;
  const face_grade = user_submission.face_grade;
  const is_ai_graded = user_submission.ai_grade?.length > 0;

  let value = user_submission.grade >= 0 ? user_submission.grade : "-";

  if (!is_ai_graded && manualGrading && isAllTab && !value && !is_game && !is_debate && !is_loteria && !is_worksheet) {
    value = "-";
  }

  value = retaking && !is_ai_graded && value == 0 ? "-" : value;

  let isLate = !!user_submission.isLate;

  if (!isNaN(value)) {
    if (scale_1_5 && value != null && value !== "") {
      let _g = value <= 0 ? 0 : floor((value - 1) / 20);
      value = `${_g > 4 ? 4 : _g}`;
    } else if (gradebook_a_f && value != null) {
      value = af_grade(value);
    }
  }

  return {
    value: is_ai_graded ? value : (isAllTab && manualGrading && value == 0 ? '-' : value),
    isTbg,
    isLate,
    isDiffStudent,
    manualGrading,
    completeTbg: isAllTab,
    hasAssigned,
    face_grade,
    point_system,
    complete_incomplete,
    is_game,
    is_debate,
    is_loteria,
    is_worksheet,
  };
}, [userPreference?.gradePref, getStudentSubmissionByAssignmentId, currentClass, scale_1_5, gradebook_a_f]);

    const userNav = (user) => {
        const has_assignment = orderedActiveSemData.filter(obj => obj && obj.id).length > 0
        const items = [
            {
                key: 'login-as',
                label: (
                    <div
                        style={{ color: !user.active ? COLOR.red : COLOR.black100 }}
                        onClick={() => {
                            if (!user || !user.active) return;
                            if (user && user.id) {
                                setLoginAsUserId(user.id)
                                setLoginAsModal(true);
                            }
                        }}
                    >
                        Login as Student {!user.active ? "(Inactive)" : ""}
                    </div>
                ),
                disabled: !user || !user.active
            },
            {
                key: 'login-as-parent',
                label: (
                    <div
                        style={{ color: !user.active ? COLOR.red : COLOR.black100 }}
                        onClick={async () => {
                            if (!user || !user.active) return;
                            if (user && user.id) {
                                setLoginAsParentLoader(true);
                                const response = await dispatch(handleGetParentByStudentId(user.id))
                                if(response && response?.length > 0){
                                    setParentLoginUser(response)
                                    setLoginAsParentModal(true);
                                }else{
                                    showAlert("No active parent for this account.", "info")
                                }
                                setLoginAsParentLoader(false);
                                
                            }
                        }}
                    >
                        Login as Parent {!user.active ? "(Inactive)" : ""}
                    </div>
                ),
                disabled: !user || !user.active
            },
            {
                key: 'invite-parent',
                label: (
                    <div onClick={() => {
                        if (user && user.id) {
                            setInviteParentModal(true)
                            setSelectedUser(user);
                        }
                    }}>
                        Invite parent
                    </div>
                )
            },
            {
                key: 'report-issue',
                label: (
                    <div onClick={() => {
                        if (user && user.id) {
                            setReportIssueModal({
                                open: true,
                                studentId: user.id,
                                studentName: `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.username
                            });
                        
                        }
                    }}>
                        Report an issue
                    </div>
                )
            }
        ];
        
        if (!isReviewAccount) {
            items.push({
                key: 'student-differentiation',
                label: (
                    <div style={{ color: !user.active ? COLOR.red : COLOR.black100 }}
                    onClick={() => {
                        if (!user || !user.active) return;
                        if (user?.id) {
                            setStudentDiffInitialIds([user.id]);
                            setStudentDiffModalOpen(true);
                        }
                    }}>
                        Student differentiation
                    </div>
                ),
                disabled: !user || !user.active
            });
        }
        
        if (!isUserFromOtherPlatform) {
            items.push(
                {
                    key: 'edit',
                    label: (
                        <div onClick={() => {
                            setUserData({
                                editing: true,
                                ...user
                            });
                            setEditing(true);
                            toggleUserDrawer(true);
                        }}>
                            Edit
                        </div>
                    )
                }
            );
            items.push({
                key: 'change-password',
                label: (
                    <div onClick={() => {
                        setUserData({
                            ...user
                        });
                        toggleChangePasswordDrawer(true);
                    }}>
                        Change password
                    </div>
                )
            });
        }
        items.push(
            {
                key: 'view-submissions',
                label: (
                    <div disabled={!has_assignment} style={{ opacity: has_assignment ? 1 : 0.5 }} onClick={() => {
                        if(!has_assignment) return;
                        const filterActiveSemData = orderedActiveSemData.filter(obj => Object.keys(obj).length > 0);
                        userReviewAssignment(user, filterActiveSemData)
                    }}>
                        View Submissions
                    </div>
                )
            },
            {
                key: 'view-credentials',
                label: (
                    <div
                        onClick={() => {
                            setPasswordViewerUser(user);
                            setPasswordViewerOpen(true);
                        }}
                    >
                        View username and password
                    </div>
                )
            }
        );
        
        if (!isUserFromOtherPlatform) {
            items.push({
                key: 'remove',
                label: (
                    <div onClick={() => {
                        setSelectedUser(user);
                        setModalState(true);
                    }}>
                        Remove
                    </div>
                )
            });
        }
        
        return items;
    };
    
    const sortingNav = (user) => {
        return NAME_SHORTING.map(item => ({
            key: item.title,
            label: (
                <div 
                    onClick={() => {
                        setNameShortType(item)
                        setSortBy(item.key)
                    }} 
                    style={{ 
                        backgroundColor: item.key == nameShortType.key ? COLOR.indigo600 : "#fff", 
                        color: item.key == nameShortType.key ? COLOR.white : COLOR.gray100 
                    }}
                >
                    {item.title}
                </div>
            )
        }));
    };
    const getStudentSearchTarget = (user) => {
        const firstName = get(user, "firstName", "");
        const lastName = get(user, "lastName", "");
        const username = get(user, "username", "");
        if (studentSearchBy.key === "first_name") return firstName;
        if (studentSearchBy.key === "last_name") return lastName;
        if (studentSearchBy.key === "username") return username;
        return `${firstName} ${lastName} ${username}`.trim();
    };
    const checkHighlight = useCallback((sub, assign) => {
        if (!highlightConfig || !assign?.id) return false;
        return Object.entries(highlightConfig).some(([key, dt]) => {
            switch (key) {
                case 'not-submitted':
                    return !sub || !sub.id;
                case 'needs-grading':
                    return sub && sub.complete && sub.manualGrading;
                case 'missing':
                case 'absent':
                case 'excused':
                case 'exempt':
                case 'incomplete':
                    return sub && sub.exceptionStatus == dt.value;
                case 'late':
                    return sub && sub.exceptionStatus == '6';
                default:
                    return false;
            }
        });
    }, [highlightConfig]);
    const getCellStyle = useCallback((isLate, isDiffStudent, isActiveCol, is_resubmitted) => {
        const style = {};
        if (isLate) {
            style.backgroundColor = "rgba(255,0,0,0.2)";
          } 
        else if(is_resubmitted){
            style.backgroundColor = "lightYellow";
        } else if (isDiffStudent) {
          style.backgroundColor = "#00ff134f";
        }
        if (isActiveCol) {
          style.backgroundColor="#bbb5b578"
        }
        return Object.keys(style).length ? style : {};
      }, []);
    const removeUser = async () => {
        setLoading(true);
        const orgId = currentOrg.parentId !== 'null' ? currentOrg.parentId : currentOrg?.id;
        await dispatch(handleDeleteUserData(selectedUser.id, selectedUser.username, orgId, currentClass.id));
        await dispatch(handleListClassUsers(currentClass.id));
        setSelectedUser({});
        setLoading(false);
        setModalState(false);
    };

    const deleteAssignment = async (e) => {
        e.preventDefault();
        let classAssignmentIdsToDelete = [];
        if (assignmentData?.classes?.length > 0) {
            classAssignmentIdsToDelete = currentClass?.id ? [currentClass?.id] : [];
        } else {
            classAssignmentIdsToDelete = [String(assignmentData?.id)];
        }
        
        if(currentClass.googleId){
            await handleDeleteGoogleAssignment(currentUser.googleId,assignmentData.activityId || assignmentData.quizId, classAssignmentIdsToDelete)
        }
        
        if(currentUser.canvas_id){
            try {
                await handleDeleteCanvasAssignment(currentUser.canvas_id,assignmentData.activityId || assignmentData.quizId, classAssignmentIdsToDelete, currentUser.canvas_auth_id);
            } catch (error) {
                Sentry.captureException(`533 Error in handleDeleteCanvasAssignment: ${error}`);
                
            }
        }
        if (currentClass.sectionId) {
            await handleDeleteSchoologyAssignment(currentUser.schoologyid,assignmentData.activityId || assignmentData.quizId, classAssignmentIdsToDelete)
            listSchoologyAssignment(currentClass.sectionId)
        }
            
        const to_be_index =  calculateNewActiveIndex(activeIndex,numCols,numRows,deletingColumIndex)
        setSeleteAssignmentLoading(true);
        const notificationData = {
            id: v4(),
            classId: get(currentClass, "id", ""),
            displayName: get(assignmentData, "displayName", ""),
            senderId: get(currentUser, 'id', ''),
            receiversId: filterClassUsers,
            modified: moment().toISOString(),
            data: {
                chapter: get(assignmentData, "data.chapter", ""),
                page: get(assignmentData, "data.page", ""),
                id: get(assignmentData, "data.id", ""),
                assignmentType: get(assignmentData, 'type', '') || '',
            },
            message: `Your teacher Delete this ${get(assignmentData, 'type', '') === 'debate' ? 'Debate' : get(assignmentData, 'type', '') === 'game' ? 'Game' : 'Assignment'}`,
            type: "delete_activity",
            userSeen: []
        };
        const is_game = assignmentData?.type === 'game' || assignmentData?.type === 'debate' || assignmentData?.type === 'bingo' || assignmentData?.type == 'worksheet'
        try {
            if (assignmentData && assignmentData?.quizId &&!is_game) {
                await dispatch(handleDeleteClassQuiz(
                    assignmentData.quizId,
                    assignmentData.classId
                ));
            } else if (assignmentData && assignmentData.activityId &&!is_game) {
                await dispatch(handleDeleteClassActivity(
                    assignmentData.activityId,
                    assignmentData.classId
                ));
            }else if(is_game){
               await dispatch(handledeleteDebate(assignmentData.session_id))
               await fetchClassGameActivity()
               
            }
            sendNotifications(notificationData);
            if(to_be_index>0){
                setActiveIndex(to_be_index)
            }
            onDeleteSuccess()
        } catch (error) {
            Sentry.captureException(`534 Error in deleteAssignment: ${error}`);
            onDeleteSuccess()
        }

    };
    const onDeleteSuccess = () => {
        setDeleteClassAssignmentToggle(false);
        setSeleteAssignmentLoading(false)
        setAssignmentData(null)
    }
    const onExamTabClick = (tab) => {
        dispatch(updateUI({mainGradeTableActive: true}))
        setActiveGradeTab(tab);
        setGradeViw("exam")
        if (tab == "exam2") {
            const hExam = get(find(exams, k => k.order == 1), "exams[1]")
            const mExam = get(find(exams, k => k.order == 2), "exams[1]")
            const hStartDate = get(hExam, "startDate")
            const mStartDate = get(mExam, "startDate")
            if (hStartDate && mStartDate) {
                if (moment().isBefore(hStartDate) && moment().isBefore(mStartDate)) {
                    PopPupExam(`Exam is available after ${moment(hStartDate).isBefore(mStartDate) ? moment(hStartDate).format("DD/MM/YYYY") : moment(mStartDate).format("DD/MM/YYYY")}`)
                    return;
                }
            }
        } else if (tab == "exam3") {
            const hExam = get(find(exams, k => k.order == 1), "exams[2]")
            const mExam = get(find(exams, k => k.order == 2), "exams[2]")
            const hStartDate = get(hExam, "startDate")
            const mStartDate = get(mExam, "startDate")
            if (hStartDate && mStartDate) {
                if (moment().isBefore(hStartDate) && moment().isBefore(mStartDate)) {
                    PopPupExam(`Exam is available after ${moment(hStartDate).isBefore(mStartDate) ? moment(hStartDate).format("DD/MM/YYYY") : moment(mStartDate).format("DD/MM/YYYY")}`)
                    return;
                }
            }
        }
       
    }
    const handleSetgradeData = () => {
        try {
            const row1 = ['', '', '', 'Books']
            const row2 = ['', '', '', 'assignment']
            const row3 = ['', 'username', 'password', 'due date/average']
            const userData = []
            map(orderedActiveSemData, (assignment, i) => {
                let bookname = getBookDisplayName(booksAllList, assignment?.data?.chapter)
                row1.push(bookname)
                if (assignment?.data?.typeId == 'quizresource') {
                    row2.push(`${assignment?.data?.bookId}(${assignment?.displayName || assignment?.data?.displayName || ""})`)
                } else {
                    row2.push(`${getAssignmentLable(assignment, booksAllList, videos, resources)}(${assignment?.displayName || assignment?.data?.displayName || ""})`)
                }
                if (assignment?.dueDate) {
                    row3.push(`${moment(assignment?.dueDate).format("MMM DD")}`)
                } else {
                    row3.push('')
                }
            })
            map(listStudentUser, (user, i) => {
                let data = []
                data.push(`${user.lastName}, ${user.firstName}`)
                data.push(user.username)
                data.push('')
                data.push(averageGradeLookup[user.id] ?? calculateGrade(user.id))
                map(orderedActiveSemData, (assignment, i) => {
                    let { value } = calculateValue(assignment, user)
                    data.push(value)
                })

                userData[i] = data;
            })
            const finaldata = [row1, row2, row3, ...userData]
            setGradeData(finaldata)
        } catch (error) {
            Sentry.captureException(`535 Error in handleSetgradeData: ${error}`);
        }
    }
    useEffect(() => {
        const gradeDataTimer = setTimeout(() => {
            handleSetgradeData();
        }, 120);
        return () => clearTimeout(gradeDataTimer);
    }, [users, activeSemData, submissions, activeGradeTab, orderedActiveSemData, listStudentUser, averageGradeLookup]);
    const onSemClick = async (key) => {
        const currentYear = parseInt(moment().format("YYYY"))
        let yearc = parseInt(key.split("-")[1])
        if (key == currentSem || yearc <= currentYear) {
            setActiveSem(key)
            setActiveSemData(semAssignment[key])
            onSemesterChange && onSemesterChange(key,semAssignment[key]) // Notify parent
            if (currentClass?.id) {
                const isPreviousSem = key !== currentSem;
                if(!isPreviousSem) return;
                try {
                    setSemesterSwitchLoading(true);
                    await dispatch(handleListClassSubmissions(currentClass?.id, false, parentOrgId, isPreviousSem));
                } finally {
                    setSemesterSwitchLoading(false);
                }
            }
        } else {
            const startMonth = key.split("-")[0].includes(1) ? "June" : "January"
            showAlert(`Available ${startMonth}  ${yearc + 1}`, 'error')
        }
    }

    const isEditable = useCallback(() => {
        if (activeSem === currentSem) return true;
        if (editPrevSemData) return false;
        return true;
    }, [editPrevSemData, activeSem, currentSem])
    const getValue=(hasAssigned,value)=>{
        return hasAssigned ? typeof value === "string" ? value.toUpperCase() : value : "N/A"
    }
    const check_to_gradeManually = (assignment) => {
        if (!assignment?.data?.questions) return false;
        return checkIsManualGradable(assignment.data.questions)
      };
    const renderedTableRows = useMemo(() => {
        if (dataLoading) return null;
        return map(listStudentUser, (user, i) => (
            <TableRow   ref={(el) => (inputRowCells.current[i] = el)}  key={get(user,"id") ? get(user,"id") : i + "user"} index={i + 1} style={{ borderLeft: '0px' }}>
                {map(displayedActiveSemData, (assignment, j) => {
                    const { value, isTbg, isLate, isDiffStudent, manualGrading , hasAssigned, face_grade , point_system , complete_incomplete , is_game , is_debate, is_loteria  , is_worksheet } = calculateValue(assignment, user)
                    const tempData = getAssignmentCreation(assignment, user)
                    const index = i * numCols + j;
                    const ungraded = get(assignment,"ungraded",false)
                    const isStory=  isStoryAssignment(assignment?.chapter||assignment?.data?.chapter)
                    const isActiveUserClass = typeof user?.userclass?.active === "boolean" ? user.userclass.active : false;
                    const has_assignment = is_game || is_loteria || is_debate  || is_worksheet? assignment?.id : assignment?.data?.id;
                    const disable_edit = !isEditable() || !hasAssigned || !isActiveUserClass || !has_assignment

                    const assignmentId =  is_game || is_loteria || is_debate || is_worksheet ?assignment.session_id:assignment?.data?.id
                    const student_submission  = getStudentSubmissionByAssignmentId(user.id, assignmentId)
                    const submissionsCount = parseInt(get(student_submission, "submissions", '0'), 10);
                    const returnedCount = parseInt(get(student_submission, "returned", 0), 10);
                    const has_to_gradeManually = check_to_gradeManually(assignment);
                    const is_resubmitted = !has_to_gradeManually &&!ungraded && submissionsCount > 0 && submissionsCount === returnedCount;
                    const submissionStatus = getSubmissionStatus(student_submission);
                    return (
                            <TableCellEditMemo
                                style={getCellStyle(isLate, isDiffStudent,checkHighlight(student_submission,assignment,isLate,isTbg,manualGrading),is_resubmitted)}
                                key={get(assignment,"id") || index}
                                ref={(el) => (inputCells.current[index] = el)}
                                minWidth={TABLE_CELL_MIN_WIDTH}
                                assignemnt={assignment}
                                student_submission={student_submission}
                                userActive={isActiveUserClass}
                                is_hidden={assignment?.is_hidden}
                            > 
                            <RenderIfVisible 
                            defaultHeight={60}  
                            visibleOffset={500} 
                            initialVisible={j<8}
                            stayRendered={isLate} 
                            placeholderElementClass={"placeholder-div"} 
                            placeholderElement='div'>
                                <GradeEditor
                                    userActive={isActiveUserClass}
                                    disabled={disable_edit}
                                    assignmentId={assignment?.id ?? (j + "assignment")}
                                    isReviewAccount={isReviewAccount}
                                    data={student_submission}
                                    reviewAssignment={(v) => reviewAssignment(v)}
                                    tempData={tempData}
                                    submission={student_submission}
                                    userId={user?.id ?? (j + "userr")}
                                    value={getValue(hasAssigned,value)}
                                    scale_1_5={scale_1_5}
                                    gradebook_a_f={gradebook_a_f}
                                    assignments={assignment}
                                    currentClass={currentClass}
                                    user={user}
                                    assignment={assignment}
                                    isTbg={isTbg && manualGrading}
                                    enterKeyListner={enterKeyListner}
                                    studentSubmissions={studentSubmissionsRef.current[user.id]}
                                    onFlagMenuViewChange={(visiblity) => {
                                      
                                    }}
                                    ref={(el) => (inputRefs.current[index] = el)}
                                    onFocus={() => {
                                        setActiveIndex(index)
                                    }}
                                    onBlur={() => { }}
                                    isLate={isLate}
                                    hasTbg={isTbg}
                                    isDiffStudent={isDiffStudent}
                                    ungraded={ungraded}
                                    face_grade={face_grade}
                                    point_system={point_system} 
                                    complete_incomplete ={complete_incomplete}
                                    submissions={submissions}
                                    isStory={isStory}
                                    history={navigate}
                                    currentUser={currentUser}
                                    in_progress={submissionStatus?.inProgressStatus || false}
                                />
                            </RenderIfVisible>
                            </TableCellEditMemo>
                    )
                })}
            </TableRow>
        ))
    }, [listStudentUser, displayedActiveSemData, calculateValue, getAssignmentCreation, numCols, isEditable, getStudentSubmissionByAssignmentId, getSubmissionStatus, checkHighlight, getCellStyle, isReviewAccount, reviewAssignment, scale_1_5, gradebook_a_f, submissions, currentClass, navigate, currentUser, dataLoading])

    const renderedStudentRows = useMemo(() => {
        return listStudentUser.map((user, i) => (
            <TableRow key={user?.id ?? i + "user"} index={i + 1} style={{ borderRight: '0px' }} ref={(el) => (nameCellRefs.current[i] = el)}>
                <UserNameCellTableCell userActive={user?.userclass?.active}>
                    <Dropdown menu={{ items: userNav(user) }} disabled={isReviewAccount || Object.keys(user ?? {}).length == 0} placement="bottomLeft" trigger={['click']}>
                        <CustomBtn onClick={e => e.preventDefault()}>
                            <MoreVert />
                        </CustomBtn>
                    </Dropdown>
                    <AntdTooltip title={getUserName(user)}>
                        {getUserName(user)}
                    </AntdTooltip>
                </UserNameCellTableCell>
                {!isDateRangeControlled && <TableCell header="true" width='208px' style={{ backgroundColor: rowThreeColor, borderBottom: '1px solid #35383d' }} />}
                <AverageTableCell header active style={{ fontSize: '14px' }}>
                    <TootipWrapper hasToolTip label={"Average grade"}>
                        {averageGradeLookup[user.id] ?? calculateGrade(user.id)}
                    </TootipWrapper>
                </AverageTableCell>
            </TableRow>
        ));
    }, [listStudentUser, isReviewAccount, isDateRangeControlled, averageGradeLookup, calculateGrade, userNav, getUserName])

    const renderDueDates = useMemo(() => {
        return (map(displayedActiveSemData, (assignment, i) => {
            const datePreference = userPreference?.order_by_date === 'due_date' ? get(assignment, "dueDate") : userPreference?.order_by_date === 'late_submission' ? get(assignment, "lateDate") || get(assignment, "dueDate"): get(assignment, "scheduleAt");
            return (
            <span key={`${i} assignment`}>
                <DueDateTableCell
                    key={`${assignment?.id} - ${i}`}
                    id={assignment?.id}
                    minWidth={TABLE_CELL_MIN_WIDTH}
                    is_hidden={assignment?.is_hidden}
                >
                    {datePreference ? <><span>{`${moment(datePreference).format("MMM DD")}`}</span> <Popover trigger="click"
                    content={<GradebookPopoverContent booksAllList={booksAllList} x={assignment} />} title="Assignment Info" placement="rightTop"> 
                        <InfoCircleFilled style={{cursor: 'pointer', marginLeft:'10px', width:'18px', height:'18px', color:'#1a1a1a'}} /> 
                    </Popover> </> : <span></span>}
                </DueDateTableCell>
            </span>
        )}))
    }, [displayedActiveSemData])

    const renderAssignmentLabel = useMemo(() => {
        return (map(displayedActiveSemData, (assignment, i) => {
            const {
                isActive,
                disabled,
                is_game,
                is_debate,
                is_worksheet,
                is_loteria,
                cell_style
            } = getAssignmentProperties(assignment)
            
            return (<span key={i + "assignment"}>
                <Dropdown menu={{ items: booknav(assignment, is_game || is_loteria || is_debate || is_worksheet ,is_debate,i) }} disabled={disabled} placement="bottomRight" trigger={['click']}>
                    <AssignmentTableCell
                        assignmentActive={isActive}
                        key={assignment?.id}
                        id={assignment?.id}
                        header="true"
                        minWidth={TABLE_CELL_MIN_WIDTH}
                        style={isActive?cell_style:{}}
                        is_hidden={assignment?.is_hidden}
                    >
                        <Tooltip title={get(assignment, "displayName", get(assignment, "data.displayName", ""))}>
                            <AssignmentLabelText>
                                {/* {is_game || is_debate ? get(assignment, "displayName", '') : getAssignmentLable(assignment, booksAllList, videos, resources)} */}
                                {get(assignment, 'displayName', get(assignment, 'data.displayName', ''))}
                                </AssignmentLabelText>
                        </Tooltip>
                        <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                    </AssignmentTableCell>
                </Dropdown>
            </span>)
        }))
    }, [displayedActiveSemData, booksAllList, videos, resources])
    const isNotSync = (assignment) => {
        if (assignment &&Object.keys(assignment).length) {
            if (isSchoologyUser) {
                return !assignment.sAssignmentId
            } else if (isCanvasUser) {
                return !assignment.canvas_id
            } else if (isGoogleUser) {
                return !assignment.googleId 
            } else {
                return false
            }
        } else {
            return false;
        }
    }
    
    const getBookLabelProperties = useCallback((assignment) => {
        const assignmentType = assignment?.type
        const is_game = assignmentType === "game"
        const is_debate = assignmentType === "debate"
        const is_worksheet = assignmentType === "worksheet"
        const is_loteria = assignmentType === "bingo"
        
        let chapter = is_game || is_loteria ? assignment.bookId : assignment?.data?.chapter
        if (is_worksheet) {
            chapter = assignment.bookId
        }
        
        const bookname = is_debate ? 'Debate' : getBookDisplayName(booksAllList, chapter, true, videos, resources)
        const is_not_sync = isNotSync(assignment)
        const is_deleted = !is_not_sync && assignment?.deleted_from_integration
        const booktooltip = is_deleted ? `This assignment is no longer available in integration` : bookname
        
        return {
            is_game,
            is_debate,
            is_worksheet,
            is_loteria,
            chapter,
            bookname,
            is_not_sync,
            is_deleted,
            booktooltip
        }
    }, [booksAllList, videos, resources])
    
    const renderBookLabel = useMemo(() => {
        return (map(displayedActiveSemData, (assignment, i) => {
            const {
                bookname,
                is_not_sync,
                is_deleted,
                booktooltip
            } = getBookLabelProperties(assignment)
            return (<span key={i + "assignment"}>
                <BookLabelTableCell
                    key={assignment?.id + i}
                    id={assignment?.id}
                    header="true"
                    minWidth={TABLE_CELL_MIN_WIDTH}
                    is_hidden={assignment?.is_hidden}
                >
                    <Tooltip title={booktooltip}><AssignmentLabelText>
                        {is_not_sync ? <SyncDisabled style={{ color: COLOR.gray100, fontSize: 12 }} /> : null}    {is_deleted ? <Warning style={{ color: COLOR.yellow, fontSize: 12 }} /> : null}  <BookNameTitle>{bookname}</BookNameTitle>
                    </AssignmentLabelText>
                    </Tooltip>
                </BookLabelTableCell>
            </span>)
        }))
    }, [displayedActiveSemData, booksAllList, videos, resources, schoologyAssignment])
    useEffect(() => {
        if (numCols <= 0) return;
        const prevIndex = previousActiveIndexRef.current;
        const nextIndex = activeIndex;
        if (prevIndex === nextIndex) return;

        const getRow = (index) => index >= 0 ? Math.floor(index / numCols) : -1;
        const getCol = (index) => index >= 0 ? index % numCols : -1;
        const prevRow = getRow(prevIndex);
        const prevCol = getCol(prevIndex);
        const nextRow = getRow(nextIndex);
        const nextCol = getCol(nextIndex);

        const toggleRowClass = (rowIndex, shouldAdd) => {
            if (rowIndex < 0) return;
            if (inputRowCells.current[rowIndex]) {
                inputRowCells.current[rowIndex].classList.toggle('selectedRowAndColumn', shouldAdd);
            }
            if (nameCellRefs.current[rowIndex]) {
                nameCellRefs.current[rowIndex].classList.toggle('selectedRowAndColumn', shouldAdd);
            }
        };

        if (prevRow !== nextRow) {
            toggleRowClass(prevRow, false);
            toggleRowClass(nextRow, true);
        } else if (nextRow >= 0) {
            toggleRowClass(nextRow, true);
        }

        const updateColumnCells = (colIndex, shouldAdd) => {
            if (colIndex < 0) return;
            for (let i = 0; i < listStudentUser.length; i += 1) {
                const index = i * numCols + colIndex;
                const cell = inputCells.current[index];
                if (!cell) continue;
                cell.classList.toggle('selectedRowAndColumn', shouldAdd);
                if (!shouldAdd) {
                    cell.classList.remove('active-input-cell');
                }
            }
        };

        if (prevCol !== nextCol) {
            updateColumnCells(prevCol, false);
            updateColumnCells(nextCol, true);
        } else if (nextCol >= 0) {
            updateColumnCells(nextCol, true);
        }

        if (prevIndex >= 0 && inputCells.current[prevIndex]) {
            inputCells.current[prevIndex].classList.remove('active-input-cell');
        }
        if (nextIndex >= 0 && inputCells.current[nextIndex]) {
            inputCells.current[nextIndex].classList.add('active-input-cell');
            onFousInput(nextIndex);
            const cell = inputCells.current[nextIndex];
            const container = tableWrapperRef.current;
            if (container && cell) {
                const containerRect = container.getBoundingClientRect();
                const cellRect = cell.getBoundingClientRect();
                if (cellRect.right > containerRect.right) {
                    container.scrollLeft += cellRect.right - containerRect.right + 20;
                } else if (cellRect.left < containerRect.left) {
                    container.scrollLeft -= containerRect.left - cellRect.left + 20;
                }
            }
        }

        previousActiveIndexRef.current = nextIndex;
    }, [activeIndex, listStudentUser.length, numCols, onFousInput])
 
    const onChangeGradeToAllValue = (txt) =>{
          if(gradebook_a_f){
            if(!txt||['a','b','c','d','e','f'].indexOf(txt.toLowerCase()) !== -1){
                setGradeToAll(txt.toUpperCase());
            }else{
                setGradeToAll(gradeToAll?gradeToAll:'');
            }
          }else if(scale_1_5){
             if(txt>=0&&txt<=4){
                setGradeToAll(txt)
             }else{
                setGradeToAll(gradeToAll?gradeToAll:'');
            }
          }else if(txt>=0&&txt<=maxPoint){
             setGradeToAll(txt)
          }else{
            setGradeToAll(gradeToAll?gradeToAll:'');
        }
    }
    const onClosePopulateGrade = () =>{
        setGradePopulateModal(false)
        setSelectedPopulateAssignment(null);
        setloaderPopulateAssignment(false);
        setGradeToAll(null);
        setShowConfirmationModal(false);
    }

    const showConfirmationForPopulate = () => {
        setShowConfirmationModal(true);
    }

    const onConfirmPopulate = async () => {
        setShowConfirmationModal(false);
        await onPopulateToAll();
    }

    const onConfirmHideActivity = async () => {
        setShowHideConfirmationModal(false);
        const { assignment, is_hidden, sub_type } = hideConfirmationData;
        if (assignment) {
            await handleHideActivity(assignment, is_hidden, sub_type);
        }
        setHideConfirmationData({ assignment: null, is_hidden: false, sub_type: null });
    }

    const getPopulateHelpingMaessage = () => {
        let message='';
        if (gradebook_a_f) {
            message = "Enter a grade between A to F";
        } else if (scale_1_5) {
            message = "Enter a grade between 0 to 4";
        } else {
            message = `Enter grade between 0 to ${maxPoint}`;
        }

        return message;
    }

    const getUserSubmissions =  (assignment, user) => {
        if (!assignment || !user) return null;
        const grade_type = assignment?.grade_type;
        const isPointSystem =  grade_type === "points"
        const is_game = assignment?.type === "game"
        const is_debate = assignment?.type === "debate"
        const is_worksheet = assignment?.type === "worksheet"
        const is_loteria = assignment?.type === "bingo"
        const hasAssigned = assignment.users == null || assignment.users.length == 0 || assignment.users.includes(user.id)
        const assignment_id = is_game || is_loteria || is_debate || is_worksheet ? assignment.session_id : get(assignment, "data.id")
        const userSubmissions = getStudentSubmissionByAssignmentId(user.id, assignment_id);
        let val = null;
        if (scale_1_5 && gradeToAll <= 4) {
            val = gradeToAll == 0 ? gradeToAll : `${(gradeToAll * 20) + 10}`
        }
        else if (gradebook_a_f && hasGradeInA_F(gradeToAll).hasValue) {
            val = hasGradeInA_F(gradeToAll).value
        }else if(isPointSystem){
            const per = (gradeToAll / maxPoint ) * 100;
            val=per;
        } else {
            if (gradeToAll >= 0 && gradeToAll <= 100) {
                val = gradeToAll;
            }
        }
        if(!val && val !==0){
           return null;
        }
        if (hasAssigned) {
            if (userSubmissions) {
                if(userSubmissions.exceptionStatus>0){
                    return null;
                }
                userSubmissions.manualGrading = false
                userSubmissions.complete = true;
                userSubmissions.graded = true;
                userSubmissions.grade = val;
                userSubmissions.face_grade = isPointSystem ? gradeToAll : userSubmissions.face_grade;
                userSubmissions.submissions = userSubmissions.submissions;
                delete userSubmissions.assignment
                delete userSubmissions.user
                return userSubmissions;
            } else {
                const tempData = getAssignmentCreation(assignment, user)
                tempData.submissions = 1;
                tempData.manualGrading = false;
                tempData.complete = true;
                tempData.graded = true;
                tempData.grade = val;
                tempData.face_grade = isPointSystem ? gradeToAll : tempData.face_grade;
                delete tempData.assignment
                delete tempData.user
                return tempData;
            }
        } else {
            return null;
        }

    };
    const updateGradetoSchoology = async (_val,statusCode,sAssignmentId,studentSchoologyIds) => {
        if (currentClass && currentClass.sectionId && studentSchoologyIds) {
            await handleGradeToSchoology({
                sectionId:currentClass?.sectionId,schoologyid:currentUser.schoologyid , statusCode:statusCode, value:_val, studentSchoologyIds, sAssignmentId:sAssignmentId
            })
        }
    }
    const updateGradetoGoogleClassRoom = async (_val, user, assignments) => {
        if (currentClass && currentClass.googleId && user && user.googleId) {
            try {
                await handleUpdateGoolgeGradeInBatch(currentUser.googleId, user.googleId, currentClass.googleId, assignments.googleId, _val)
            } catch (error) {
                Sentry.captureException(`536 Error in updateGradetoGoogleClassRoom: ${error}`);
                console.log(error, "issue in update grade to classroom");
            }
        }
    }
    const updateGradeToCanvas = async (_val, assignments, user) => {
        if (currentUser && currentUser.canvas_id && currentClass.canvas_id && assignments?.canvas_id && user) {
            await handleUpdateCanvasGradeInBatch(currentUser.canvas_id, {
                "canvas_assignment_id": assignments?.canvas_id,
                "course_id": currentClass.canvas_course_id,
                "canvas_user_id": user.canvas_id,
                "grade": _val
            }, currentUser.canvas_auth_id)
        }
    }

    const sendNotifications = async (notificationData) => {
        try {
            createCollectionNotification(notificationData, get(currentClass, 'id', ''));
        } catch (error) {
            Sentry.captureException(`537 Error in sendNotifications: ${error}`);
            console.log(error, "error")
        }
    }

    const onNotification = (submissionData, Assignment) => {
        const userIds = submissionData.map(item => item.userId);
        const typeId = get(Assignment, "assignment.typeId");
        const notificationData = {
            id: v4(),
            classId: get(currentClass, 'id', ''),
            displayName: get(Assignment, `${typeId === 'game' ? 'assignment' : 'data'}.displayName`, ''),
            senderId: get(currentUser, 'id', ''),
            receiversId: userIds,
            modified: moment().toISOString(),
            data: {
                chapter: get(Assignment, `${typeId === 'game' ? 'assignment' : 'data'}.chapter`, ''),
                page: get(Assignment, `${typeId === 'game' ? 'assignment' : 'data'}.page`, ''),
                id: get(Assignment, `${typeId === 'game' ? 'assignment' : 'data'}.id`, ''),
                assignmentType: get(assignmentData, 'type', '') || submissionData[0]?.assignmentType || "",
            },
            message: `Your Teacher Graded this ${get(Assignment, 'type', '') === 'debate' ? 'Debate' : get(Assignment, 'type', '') === 'game' ? 'Game' : get(Assignment, 'type', '') === 'bingo' ? 'Bingo' : 'Assignment'}`,
            type: 'update_grade',
            userSeen: []
        }
        sendNotifications(notificationData);
    }

    const onPopulateToAll = async () => {
        setloaderPopulateAssignment(true);
        const submissionData = map(listStudentUser, usr => getUserSubmissions(selectedPopulateAssignment, usr)).filter(k => k);
        const firstSubmssion = submissionData[0] || {};
        const grade_type = selectedPopulateAssignment?.grade_type;
        const isPointSystem = grade_type === "points"
        if (currentClass.sectionId) {
            const studentSchoologyIds = listStudentUser.map(k => k.schoologyid)
            updateGradetoSchoology(isPointSystem ? firstSubmssion.face_grade : firstSubmssion.grade, firstSubmssion.exceptionStatus, selectedPopulateAssignment.sAssignmentId, studentSchoologyIds)
        } else if (currentClass.googleId) {
            submissionData.map(sub => updateGradetoGoogleClassRoom(isPointSystem ? firstSubmssion.face_grade : firstSubmssion.grade, find(listStudentUser, ['id', sub.userId]), selectedPopulateAssignment))
        } else if (currentUser.canvas_id && currentClass.canvas_id) {
            submissionData.map(sub => updateGradeToCanvas(isPointSystem ? firstSubmssion.face_grade : firstSubmssion.grade, selectedPopulateAssignment, find(listStudentUser, ['id', sub.userId])))
        }
        if (submissionData.length > 0) {
            await dispatch(handleUpdateSubmissionsToAll(submissionData, currentClass.id));
            onNotification(submissionData, selectedPopulateAssignment)
        }
        onClosePopulateGrade()
    }
    const loginAsStudent = async ()=>{
         setLoginasLoader(true);
         await openLoginInNewWindow(loginAsUserId);
         setLoginasLoader(false);
         setLoginAsModal(false);
    }

    const loginAsParent = async (id)=>{
        try{
            setLoginasLoader(true);
            await openLoginInNewWindow(id);
            setLoginasLoader(false);
            setLoginAsParentModal(false);
            setParentLoginUser(null);
        }catch(error){
            Sentry.captureException(`538 Error in loginAsParent: ${error}`);
            console.log(error, "issue in login as parent");
        }
        
   }
   const mainGradeTableActive = useMemo(() => activeGradeTab == "", [activeGradeTab])

   useEffect(() => {
    if (!location.state?.openGradebookExam) return;
    const examTab = location.state.examTab || 'exam1';
    const classIdFromReport = location.state.selectedClassId;
    if (classIdFromReport) {
      setExamSelectedClassId(classIdFromReport);
      if (classIdFromReport !== currentClass?.id) {
        dispatch(handleGetClass(classIdFromReport));
      }
    }
    onExamTabClick(examTab);
    navigate({ pathname: location.pathname, search: location.search }, { replace: true, state: {} });
   }, [location.state?.openGradebookExam, location.state?.examTab, location.state?.selectedClassId]);

   useEffect(() => {
    if(mainGradeTableActive) {
        dispatch(updateUI({mainGradeTableActive: false}))
    }else{
        dispatch(updateUI({mainGradeTableActive: true}))
    }
   },[mainGradeTableActive])
    return (
        <SentryWrap>
            <Wrapper>
            <ModalMenu type='deactivateByStudent' assignmentData={dectiavateByStudentModal?.assignmentData} studentList={listStudentUser} open={dectiavateByStudentModal?.open} close={()=> setDectivateByStudent(({open: false, assignmentData: {}}))} />
            <ReturnAssignmentByStudent
                submissionList={returnSubmissonModal.submissionList}
                open={returnSubmissonModal.open}
                close={() => setReturnSubmission({ open: false, submissionList: [] })}
            />
             <SpinLoader dataloader={loginAsParentLoader || semesterSwitchLoading} />
            <ParentLogin
             loginAsParentModal={loginAsParentModal}
              setLoginAsParentModal={setLoginAsParentModal} 
              parentLoginUser={parentLoginUser} 
              setParentLoginUser={setParentLoginUser} 
              loginasLoader={loginasLoader} 
              loginAsParent={loginAsParent} />
            <Modal
                open={loginAsModal}
                onClose={() => setLoginAsModal(false)}
            >
                <ModalContent>
                       You will login as your student, any changes you make will be APPLIED to this account.
                    <ModalRow>
                        <Button
                            className='studentLoginCanel'
                            onClick={() => {
                                setLoginAsModal(false)
                                setLoginAsUserId(null)
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={loginAsStudent}
                        >
                            {loginasLoader ? <Loading size={20} white /> : 'Login as Student'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            
       
            <Modal
                open={gradePopulateModal}
                onClose={onClosePopulateGrade}
            >
                <ModalContent className='populateGrdPopUp'>
                <div style={{marginBottom:"15px"}}>Populate the grade, and it will update all students with a similar grade.</div>
                    <TextField
                        id="outlined-required"
                        label="Enter a grade"
                        placeholder='Enter a grade'
                        variant="outlined"
                        value={gradeToAll}
                        helperText={getPopulateHelpingMaessage()}
                        onChange={e=>onChangeGradeToAllValue(e.target.value)}
                        margin='10px'
                        autoFocus
                    />
                    <ModalRow>
                        <Button
                            style={{ marginRight: '4px' }}
                            onClick={onClosePopulateGrade}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={showConfirmationForPopulate}
                            disabled={!gradeToAll||loaderPopulateAssignment}
                        >
                            {loaderPopulateAssignment ? <Loading size={20} white /> : 'Update'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            
            {/* Confirmation Modal */}
            <Modal
                open={showConfirmationModal}
                onClose={() => setShowConfirmationModal(false)}
            >
                <ModalContent className='confirmationModal'>
                    <div style={{marginBottom:"15px", fontWeight: "bold", color: "#d32f2f"}}>
                        ⚠️ Warning
                    </div>
                    <div style={{marginBottom:"20px"}}>
                        It will override all graded grades for this assignment. Do you agree?
                    </div>
                    <ModalRow>
                        <Button
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                                setShowConfirmationModal(false);
                                onClosePopulateGrade();
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={onConfirmPopulate}
                        >
                            Yes, Update All
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            {/* Hide Confirmation Modal */}
            <Modal
                open={showHideConfirmationModal}
                onClose={() => setShowHideConfirmationModal(false)}
            >
                <ModalContent className='confirmationModal'>
                    <div style={{marginBottom:"15px", fontWeight: "bold", color: "#d32f2f"}}>
                        ⚠️ Warning
                    </div>
                    <div style={{marginBottom:"20px"}}>
                        Do you want to {hideConfirmationData.is_hidden ? "show" : "hide"} this activity?
                    </div>
                    <ModalRow>
                        <Button
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                                setShowHideConfirmationModal(false);
                                setHideConfirmationData({ assignment: null, is_hidden: false, sub_type: null });
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={onConfirmHideActivity}
                        >
                            Yes
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            
            <ParentInvitationModal
                open={inviteParentModal}
                selectedUser={selectedUser}
                onClose={() => {
                    setInviteParentModal(false);
                    setSelectedUser({})
                }}
                currentUser={currentUser}
            />
            <ReportIssueModal
                open={reportIssueModal.open}
                onClose={() => {
                    setReportIssueModal({ open: false, studentId: null, studentName: '' });
                }}
                studentName={reportIssueModal.studentName}
                studentId={reportIssueModal.studentId}
                socketConnection={socketConnection}
                reCreateSocket={reCreateSocket}
                currentUser={currentUser}
                currentClass={currentClass}
            />
            {!isReviewAccount && currentClass?.id ? (
                <StudentDifferentiationBulkModal
                    open={studentDiffModalOpen}
                    onClose={() => {
                        setStudentDiffModalOpen(false);
                        setStudentDiffInitialIds([]);
                    }}
                    classId={currentClass.id}
                    currentUserId={currentUser?.id}
                    classUsers={users}
                    classActivities={classActivities ?? []}
                    classQuizzes={classQuizzes ?? []}
                    booksAllList={booksAllList}
                    initialStudentIds={studentDiffInitialIds}
                />
            ) : null}
            <Modal
                open={open}
                onClose={() => setModalState(false)}
            >
                <ModalContent>
                    Are you sure you want to remove this student? All information and assignment submissions will be deleted.
                    <ModalRow>
                        <Button
                            style={{ marginRight: '4px' }}
                            onClick={() => {
                                setModalState(false)
                                setSelectedUser({})
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={removeUser}
                        >
                            {loading ? <Loading size={20} white /> : 'Remove'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            <Modal
                open={downloadTypeModal.open}
                onClose={() => setDownloadTypeModal({ open: false, assignmentId: null, includeTbg: false })}
            >
                <ModalContent>
                    <div style={{ marginBottom: '20px', fontWeight: 'bold' }}>
                        Select Download Format
                    </div>
                    <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center' }}>
                        <input
                            type="checkbox"
                            checked={downloadTypeModal.includeTbg}
                            onChange={(e) => setDownloadTypeModal({ ...downloadTypeModal, includeTbg: e.target.checked })}
                            style={{ marginRight: '8px' }}
                        />
                        <label>Include TBG</label>
                    </div>
                    <ModalRow>
                        <Button
                            style={{ marginRight: '8px' }}
                            color="primary"
                            variant="contained"
                            onClick={() => {
                                if (gradeDownloaderRef?.current && downloadTypeModal.assignmentId) {
                                    gradeDownloaderRef.current.downloadSpecificAssignment(downloadTypeModal.assignmentId, 'xls', downloadTypeModal.includeTbg);
                                }
                                setDownloadTypeModal({ open: false, assignmentId: null, includeTbg: false });
                            }}
                        >
                            XLS
                        </Button>
                        <Button
                            style={{ marginRight: '8px' }}
                            color="primary"
                            variant="contained"
                            onClick={() => {
                                if (gradeDownloaderRef?.current && downloadTypeModal.assignmentId) {
                                    gradeDownloaderRef.current.downloadSpecificAssignment(downloadTypeModal.assignmentId, 'csv', downloadTypeModal.includeTbg);
                                }
                                setDownloadTypeModal({ open: false, assignmentId: null, includeTbg: false });
                            }}
                        >
                            CSV
                        </Button>
                        <Button
                            onClick={() => setDownloadTypeModal({ open: false, assignmentId: null, includeTbg: false })}
                        >
                            Cancel
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            <PasswordViewerModal
                open={passwordViewerOpen}
                user={passwordViewerUser}
                onClose={() => {
                    setPasswordViewerOpen(false);
                    setPasswordViewerUser(null);
                }}
            />
            <Modal
                open={deleteClassAssignmentToggle}
                onClose={() => setDeleteClassAssignmentToggle(false)}
            >
                <ModalContent>
                    Are you sure you want to delete the assignment? All grades will be removed as well.
                    <ModalRow>
                        <Button
                            style={{ marginRight: '4px' }}
                            onClick={() => onDeleteSuccess()}
                            disabled={deleteAssignmentLoading}
                        >
                            Cancel
                        </Button>
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={(e) => deleteAssignmentLoading ? null : deleteAssignment(e)}
                            className={`${deleteAssignmentLoading ? "disabled-button" : ""}`}
                        >
                            {deleteAssignmentLoading ? <Loading size={20} white /> : 'Yes'}
                        </Button>
                    </ModalRow>
                </ModalContent>
            </Modal>
            {dataLoading ? (
                <Loading />
            ) : (
                    <>
                    {mainGradeTableActive ? (
                        <StudentFilterWrap className='mb-10px'>
                            <StudentSearchInputWrap>
                                <Search style={{ fontSize: '14px', color: COLOR.gray100, marginRight: '4px' }} />
                                <StudentSearchInput
                                  ref={assignmentSearchInputRef}
                                 onChange={(e) => debouncedSetAssignmentSearchQuery(e.target.value)}
                                 placeholder="Search assignments"
                              />
                                <Acent inputRef={assignmentSearchInputRef} setValue={debouncedSetAssignmentSearchQuery} style={{ marginLeft: 6, display:"flex", justifyContent:"flex-end" }} />
                                </StudentSearchInputWrap>
                            <StudentSearchInputWrap>
                                <Search style={{ fontSize: '14px', color: COLOR.gray100, marginRight: '4px' }} />
                                <StudentSearchInput
                                  ref={studentSearchInputRef}
                                 onChange={(e) => debouncedSetStudentSearchQuery(e.target.value)}
                                 placeholder="Search students"
                              />
                                <Acent inputRef={studentSearchInputRef} setValue={debouncedSetStudentSearchQuery} style={{ marginLeft: 6, display:"flex", justifyContent:"flex-end" }} />
                                </StudentSearchInputWrap>
                            </StudentFilterWrap>
                            ) : null}
                    {mainGradeTableActive ?
                            <Container className="gradeBookScrollbar">
                                <Grid>
                                    <HeaderRow>
                                        <StickyCell isHeader left={0} style={{ padding: 0, marginBottom: 0, borderBottom: "1px solid" }}>
                                        <TableCellExam header="true" width='415px' style={{ width: '100%', backgroundColor: rowSemester, color: 'white', height: '30px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', justifyContent: "center", position: "sticky", top: 0, zIndex: 21, borderBottom:"1px solid #35383d" }}
                                            onClick={() => {
                                                onExamTabClick("exam1")
                                            }}>
                                            <div>
                                                Exams
                                            </div>
                                        </TableCellExam>
                                            <div style={{ display: 'flex', position: "sticky", top: 30, zIndex: 21, borderBottom:"1px solid #35383d"}}>
                                            {Object.keys(semAssignment).map((key, index) => {
                                                CountSemester = Object.keys(semAssignment).length
                                                return (
                                                    <TableCellSemester header="true" width={"208px"} style={{ backgroundColor: rowSemester, color: 'white', height: "30px", fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', justifyContent: "center" }}
                                                        active={key == activeSem} key={key} onClick={() => onSemClick(key)}>
                                                        {key}
                                                    </TableCellSemester>
                                                )
                                            })
                                            }
                                            </div>
                                            {CountSemester === 1 &&
                                                <div style={{display:'flex'}}>
                                                    <TableCellSemester header="true" width='208px' style={{ backgroundColor: rowTwoColor, color: 'white', height: '30px', fontSize: '12px', fontWeight: 'bold', justifyContent: "center" }}></TableCellSemester>
                                                </div>
                                            }
                                            <div style={{ display: 'flex', position: "sticky", top: 60, zIndex: 21, borderBottom: "1px solid #35383d" }}>
                                            <Dropdown menu={{ items: sortingNav() }} trigger={['click']}>
                                                <TableCell header="true" width='208px' style={{ backgroundColor: rowThreeColor, color: 'black', height: '30px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', justifyContent: "center" }}>
                                                    <div>
                                                        {nameShortType.title}
                                                    </div>
                                                    <CaretDownOutlined style={{ fontSize: '11px', marginLeft: '6px' }} />
                                                </TableCell>
                                            </Dropdown>
                                            {!isDateRangeControlled && (
                                                <TableCell header="true" width='208px' style={{ backgroundColor: rowThreeColor, color: 'black', height: '30px', fontSize: '12px', fontWeight: 'bold', justifyContent: "center", padding: '4px 8px' }}>
                                                    <div style={{ minWidth: 140 }}>
                                                        <DateRangeDropdown
                                                            value={gradeTableDateRange}
                                                            onDatePicked={setGradeTableDateRange}
                                                            activeSem={activeSem}
                                                            parentOrgId={parentOrgId}
                                                        />
                                                    </div>
                                                </TableCell>
                                            )}
                                            <TableCell header="true" width={"208px"} style={{ backgroundColor: rowThreeColor, color: 'black', height: '30px', fontSize: '12px', fontWeight: 'bold', justifyContent: "center" }}>Average</TableCell>
                                            </div>
                                            {listStudentUser.length === 0 ? (
                                                <TableRow index={1} style={{ borderRight: '0px' }}>
                                                    <UserNameCellTableCell style={{ height: 'auto', minHeight: TABLE_CELL_HEIGHT, whiteSpace: 'normal', overflow: 'visible' }}>
                                                        <StudentEmptyPlaceholder>
                                                            {studentSearchQuery.trim() ? "No students match this search." : "Currently 0 students enrolled in this class."}
                                                        </StudentEmptyPlaceholder>
                                                    </UserNameCellTableCell>
                                                    {!isDateRangeControlled && <TableCell header="true" width='208px' style={{ backgroundColor: COLOR.white, borderBottom: `1px solid ${COLOR.black100}` }} />}
                                                    <AverageTableCell header active style={{ backgroundColor: COLOR.white, borderBottom: `1px solid ${COLOR.black100}` }} />
                                                </TableRow>
                                            ) : renderedStudentRows}
                                        </StickyCell>
                                        <TableWrapperInner2
                                            ref={tableWrapperRef}
                                            style={showAssignmentSearchEmpty ? { minHeight: assignmentSearchEmptyMinHeight } : undefined}
                                        >
                                            <OverflowTwo>
                                                <Table>
                                                    <TableHeader stickyTop={"0px"} style={{ padding: 0, marginBottom: 0, borderBottom: "1px solid" }}>
                                                        {renderBookLabel}
                                                    </TableHeader>
                                                    <TableHeader stickyTop={"30px"} style={{ padding: 0, marginBottom: 0, borderBottom: "1px solid" }}>
                                                        {renderAssignmentLabel}
                                                    </TableHeader>
                                                    <TableHeader stickyTop={"60px"} style={{ padding: 0, marginBottom: 0, borderBottom: "1px solid" }}>
                                                        {renderDueDates}
                                                    </TableHeader>
                                                    {listStudentUser.length === 0 ? (
                                                        <TableRow index={1} style={{ borderLeft: '0px' }}>
                                                            <TableCell minWidth={TABLE_CELL_MIN_WIDTH * Math.max(numCols, 1)} style={{ height: 'auto', minHeight: TABLE_CELL_HEIGHT, whiteSpace: 'normal', overflow: 'visible', justifyContent: 'center', borderBottom: `1px solid ${COLOR.black100}`, backgroundColor: COLOR.white }}>
                                                                <StudentEmptyPlaceholder>
                                                                    {studentSearchQuery.trim() ? "No students match this search." : "Currently 0 students enrolled in this class."}
                                                                </StudentEmptyPlaceholder>
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : renderedTableRows}
                                                </Table>
                                            </OverflowTwo>
                                        </TableWrapperInner2>
                                    </HeaderRow>
                                   
                                    </Grid>
                            </Container> : <ExamTables
                            onClose={() => {
                                setActiveGradeTab(""); setGradeViw('gradetable')
                            }}
                            onExamTabClick={onExamTabClick}
                            activities={activities}
                            dataLoading={dataLoading}
                            quizzes={quizzes}
                            users={users}
                            submissions={submissions}
                            currentUser={currentUser}
                            classActivities={classActivities}
                            classQuizzes={classQuizzes}
                            setExamData={setExamData}
                            examType={activeGradeTab}
                            exams={sortExam()}
                            open={!mainGradeTableActive}
                            initialSelectedClassId={examSelectedClassId}
                        />}
                        </>
            )}
            </Wrapper>
        </SentryWrap>
    );
};


export default GradeTable;
